import endPoints from '../../config/endPoints';
import { constants, utils } from '../../devUtils';

const PROPEL_CONSTANTS = Object.freeze({
  REWARDS: [
    {
      keyIndex: 0,
      image: endPoints.PROPEL_HAPINESS.URL,
      alt: endPoints.PROPEL_HAPINESS.ALT,
      htmlData: `<h4>Order customized cards  </h4>
      <p>Customized cards with employee name and your company logo</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.PROPEL_REWARDS.URL,
      alt: endPoints.PROPEL_REWARDS.ALT,
      htmlData: `<h4>Performance</h4>
      <p>Motivated employees perform better than other employees</p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.PROPEL_RETENTION.URL,
      alt: endPoints.PROPEL_RETENTION.ALT,
      htmlData: `<h4>Retention</h4>
      <p>Employees who are engaged will result in higher productivity</p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.PROPEL_PROFITABILITY.URL,
      alt: endPoints.PROPEL_PROFITABILITY.ALT,
      htmlData: `<h4>Profitability</h4>
      <p>Productive environment results in better bottom-lines</p>`,
    },
  ],
  REWARDS_PLATFORM: [
    {
      keyIndex: 0,
      image: endPoints.PROPEL_P2P_REWARD.URL,
      alt: endPoints.PROPEL_P2P_REWARD.ALT,
      htmlData: 'Peer-to-Peer Reward',
    },
    {
      keyIndex: 1,
      image: endPoints.PROPEL_PERFORMANCE_REWARD.URL,
      alt: endPoints.PROPEL_PERFORMANCE_REWARD.ALT,
      htmlData: 'Performance Rewards',
    },
    {
      keyIndex: 2,
      image: endPoints.PROPEL_PERSONAL_OCCASION.URL,
      alt: endPoints.PROPEL_PERSONAL_OCCASION.ALT,
      htmlData: 'Rewards For Personal Occasions',
    },
    {
      keyIndex: 3,
      image: endPoints.PROPEL_WELLNESS_BENIFITS.URL,
      alt: endPoints.PROPEL_WELLNESS_BENIFITS.ALT,
      htmlData: 'Employee Wellness Benefits',
    },
  ],
  INCENTIVE_PROGRAM: [
    {
      keyIndex: 0,
      image: endPoints.PROPEL_INCREASE_FOCUS.URL,
      alt: endPoints.PROPEL_INCREASE_FOCUS.ALT,
      htmlData: `<p><br />Increase focus on <br />cross-selling & up-selling
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.PROPEL_ENHANCE_SALES.URL,
      alt: endPoints.PROPEL_ENHANCE_SALES.URL,
      htmlData: `<p><br />Ensure consistency in <br />performance
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.PROPEL_ATTRACT_TALENT.URL,
      alt: endPoints.PROPEL_ATTRACT_TALENT.ALT,
      htmlData: `<p><br />Attract talent by enhancing <br />the "Employer Brand"
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.PROPEL_ENHANCE_SALES.URL,
      alt: endPoints.PROPEL_ENHANCE_SALES.ALT,
      htmlData: `<p><br />Enhance Sales by incentivising <br />high performers
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.PROPEL_DRIVE_MULTIPLE.URL,
      alt: endPoints.PROPEL_DRIVE_MULTIPLE.ALT,
      htmlData: `<p><br />Drives multiple achievements & new <br />competency developments
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.PROPEL_DRIVE_LONGEVITY.URL,
      alt: endPoints.PROPEL_DRIVE_LONGEVITY.ALT,
      htmlData: `<p><br />Drive Longevity in <br />the organization
      </p>`,
    },
  ],
  HOW_IT_WORKS: [
    {
      keyIndex: 0,
      image: endPoints.PROPEL_SET_BUDGET.URL,
      alt: endPoints.PROPEL_SET_BUDGET.ALT,
      htmlData: `<h4>Set your Budget    </h4>
      <p>Completely customizable budget for your reward programs</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.PROPEL_RECOGNISE.URL,
      alt: endPoints.PROPEL_RECOGNISE.ALT,
      htmlData: `<h4>Recognise and motivate</h4>
      <p>Acknowledge your employees  and their performances</p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.PROPEL_DISTRUBUTE_REWARDS.URL,
      alt: endPoints.PROPEL_DISTRUBUTE_REWARDS.ALT,
      htmlData: `<h4>Distribute Rewards     </h4>
      <p>Reward your workforce with Zaggle points as you wish</p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.PROPEL_REDEEM_SITE.URL,
      alt: endPoints.PROPEL_REDEEM_SITE.ALT,
      htmlData: `<h4>Redeem at site</h4>
      <p>Employees choose their own gifts from Zaggle’s site</p>`,
    },
  ],
  BUSINESS_LOVE_ZAGGLE: [
    {
      keyIndex: 0,
      htmlData: `<h3>1. Brand Vouchers based Rewards</h3>
      <p>Choose all kinds of vouchers from a wide range of popular brands, be it shopping or entertainment</p>`,
    },
    {
      keyIndex: 1,
      htmlData: `<h3>2. High On Acceptance</h3>
      <p>Our gift cards are on Visa/Master network which are accepted across one million merchants depending on the card construct</p>`,
    },
    {
      keyIndex: 2,
      htmlData: `<h3>3. Micro-site</h3>
      <p>The microsite is a self-handled portal hosting reward catalogue, with booking and checkout functionality integrated with customization</p>`,
    },
    {
      keyIndex: 3,
      htmlData: `<h3>4. Scheduled Disbursements</h3>
      <p>Send reward points automatically on special occasions like birthdays, anniversaries, and performance milestones </p>`,
    },
    {
      keyIndex: 4,
      htmlData: `<h3>5. Real Time Reports </h3>
      <p>Zaggle informs you of the total points, as well as those recharged or redeemed, and the entire control of the program is at your fingertips </p>`,
    },
  ],
});

const EDGE_CONSTANTS = Object.freeze({
  HOW_IT_WORKS: [
    {
      keyIndex: 0,
      alt: endPoints.HIW_CUSTOMIZE_CARD.ALT,
      image: endPoints.HIW_CUSTOMIZE_CARD.URL,
      htmlData: `<h4>Order customized cards  </h4>
      <p>customized cards with Employee name and your company logo </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.HIW_DISTRIBUTE.URL,
      alt: endPoints.HIW_DISTRIBUTE.ALT,
      htmlData: `<h4>Distribute physical/ecard </h4>
      <p>Distribute physical cards to your<br /> workforce</p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.HIW_EMP_SPENDING.URL,
      alt: endPoints.HIW_EMP_SPENDING.ALT,
      htmlData: `<h4>Employee spends </h4>
      <p>Employee can spend the amount across online & offline stores</p>`,
    },
  ],
  DIGITIZE_SPENDS: [
    {
      keyIndex: 0,
      image: endPoints.DS_SAVE_TIME.URL,
      alt: endPoints.DS_SAVE_TIME.ALT,
      htmlData: `<h4>Save time and efforts</h4>
          <p>We take the hassle out of vendor<br /> management, packaging and logistics</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.DS_CUSTOMIZE.URL,
      alt: endPoints.DS_CUSTOMIZE.ALT,
      htmlData: `<h4>Customize the cards</h4>
      <p>Print the Employee name and<br /> achievement on the card </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.DS_COMP_DIGITAL.URL,
      alt: endPoints.DS_COMP_DIGITAL.ALT,
      htmlData: `<h4>Completely digital</h4>
      <p>Make orders and send the gifts<br /> electronically.</p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.DS_NO_LOCATION.URL,
      alt: endPoints.DS_NO_LOCATION.ALT,
      htmlData: `<h4>Zero pilferage, zero loss</h4>
      <p>Enjoy complete transparency<br /> regarding gifting</p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.DS_ZERO_PILFERAGE.URL,
      alt: endPoints.DS_ZERO_PILFERAGE.ALT,
      htmlData: `<h4>No location constraints</h4>
      <p>Gift your staff at different locations,<br /> locally or globally.</p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.DS_SAVE_TAX.URL,
      alt: endPoints.DS_SAVE_TAX.ALT,
      htmlData: `<h4>Save Tax</h4>
      <p>One of the most innovative tax saving <br />resulting in over Rs. 80k savings.</p>`,
    },
  ],
  GIFT: [
    {
      keyIndex: 0,
      image: endPoints.GIFT_MILESTONE.URL,
      alt: endPoints.GIFT_MILESTONE.ALT,
      htmlData: `<p>Milestone awards
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.GIFT_INDUCTION.URL,
      alt: endPoints.GIFT_INDUCTION.ALT,
      htmlData: `<p>Employee induction
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.GIFT_PERFORMANCE.URL,
      alt: endPoints.GIFT_PERFORMANCE.ALT,
      htmlData: `<p>Performance awards
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.GIFT_INCENTIVE.URL,
      alt: endPoints.GIFT_INCENTIVE.ALT,
      htmlData: `<p>Incentives
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.GIFT_BIRTHDAY.URL,
      alt: endPoints.GIFT_BIRTHDAY.ALT,
      htmlData: `<p>Birthdays
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.GIFT_FESTIVE.URL,
      alt: endPoints.GIFT_FESTIVE.ALT,
      htmlData: `<p>Festive gifting
      </p>`,
    },
    {
      keyIndex: 6,
      image: endPoints.GIFT_CHANNEL.URL,
      alt: endPoints.GIFT_CHANNEL.ALT,
      htmlData: `<p>Channel gifting
      </p>`,
    },
    {
      keyIndex: 7,
      image: endPoints.GIFT_ANNIVERSARY.URL,
      alt: endPoints.GIFT_ANNIVERSARY.ALT,
      htmlData: `<p>Work anniversaries
      </p>`,
    },
    {
      keyIndex: 8,
      image: endPoints.GIFT_LONG_SERVICE.URL,
      alt: endPoints.GIFT_LONG_SERVICE.ALT,
      htmlData: `<p>Long-service awards
      </p>`,
    },
    {
      keyIndex: 9,
      image: endPoints.GIFT_LONG_SERVICE.URL,
      alt: endPoints.GIFT_LONG_SERVICE.ALT,
      htmlData: `<p>Long-service awards
      </p>`,
    },
  ],
  CARD: [
    {
      keyIndex: 0,
      image: '',
      alt: endPoints.CARD_KUBER_CARD.ALT,
      cardImage: endPoints.CARD_KUBER_CARD.URL,
      cardImageAlt: endPoints.CARD_KUBER_CARD.ALT,
      htmlData: `<p>The KUBER gift card is widely accepted at over 750,000 merchant partners across ALL categories such as supermarkets, hypermarkets, restaurants, fuel stations, jewelry stores, hotels and all eCommerce sites<br /><br />Except for withdrawing cash, you can purchase anything under the sun using the Kuber card.
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.CARD_BOMB.URL,
      alt: endPoints.CARD_BOMB.ALT,
      cardImage: endPoints.CARD_BOMB_CARD.URL,
      cardImageAlt: endPoints.CARD_BOMB_CARD.ALT,
      htmlData: `<p>The BoMB gift card is designed for entertainment and accepted at movies, spas, theme parks and entertainment zones at the brands listed below:
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.CARD_ZEON.URL,
      alt: endPoints.CARD_ZEON.ALT,
      cardImage: endPoints.CARD_ZEON_CARD.URL,
      cardImageAlt: endPoints.CARD_ZEON_CARD.ALT,
      htmlData: `<p>The ZEON gift card is designed to offer a select choice of popular retail brands for consumer electronics, lifestyle products, footwear, travel portals, furniture portals and kitchenware as listed below:
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.CARD_WAVES.URL,
      alt: endPoints.CARD_WAVES.ALT,
      cardImage: endPoints.CARD_WAVE_CARD.URL,
      cardImageAlt: endPoints.CARD_WAVE_CARD.ALT,
      htmlData: `<p>The Wave Gift Card is designed to offer the choicest mix of brands for the apparels, entertainment, electronics, home furnishings, online shopping, jewelry and dining. This allows the freedom to spend at any of the below brands:
      </p>`,
    },
    {
      keyIndex: 4,
      image: '',
      alt: 'Zaggle wheel Gift Card',
      cardImage: endPoints.CARD_WHEEL_CARD.URL,
      cardImageAlt: endPoints.CARD_WHEEL_CARD.ALT,
      htmlData: `<p>The WHEELS gift card from Zaggle can be used for automobile purchases across India.
      </p>`,
    },
    {
      keyIndex: 5,
      image: '',
      alt: 'Zaggle Petro Card',
      cardImage: endPoints.CARD_PETRO_CARD.URL,
      cardImageAlt: endPoints.CARD_PETRO_CARD.ALT,
      htmlData: `<p>The PETRO card from Zaggle is accepted at all fuel stations that have a EDC machine as a payment for fuel and lubricants.
      </p>`,
    },
    {
      keyIndex: 6,
      image: '',
      alt: 'Zaggle kohinoor Card',
      cardImage: endPoints.CARD_KOHINOOR_CARD.URL,
      cardImageAlt: endPoints.CARD_KOHINOOR_CARD.ALT,
      htmlData: `<p>The KOHINOOR is accepted at ALL jewelry retail stores that accept cards as a means of payment and online jewelry portals like bluestone.com and caratlane.com
      </p>`,
    },
  ],
  EMP_GIFTING: [
    {
      keyIndex: 0,
      image: endPoints.EMP_GIFT_ENGAGEMENT.URL,
      alt: endPoints.EMP_GIFT_ENGAGEMENT.ALT,
      htmlData: `<h2>Better Employee<br /> Engagement</h2>
      <p>When employees are engaged, they want to work harder and smarter. Staff gifting encourages positive and productive behavior so that they put discretionary effort into their work.
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.EMP_GIFT_RETENTION.URL,
      alt: endPoints.EMP_GIFT_RETENTION.ALT,
      htmlData: `<h2>Increase Employee<br /> Retention</h2>
      <p>By routinely acknowledging the work of your team members, you will find that more of your high potential team members will stick around rather than looking opportunities elsewhere.
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.EMP_GIFT_IMPROVE_HAPPINESS.URL,
      alt: endPoints.EMP_GIFT_IMPROVE_HAPPINESS.ALT,
      htmlData: `<h2>Improve Motivation</h2>
      <p>Employees that are recognized for what they do generally report feeling happier overall about their work, resulting in more productivity, better workplace relationships, longer tenures, and more.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.EMP_GIFT_PROMOTE_INNOVATION.URL,
      alt: endPoints.EMP_GIFT_PROMOTE_INNOVATION.ALT,
      htmlData: `<h2>Promote Innovation</h2>
      <p>You and your employees will start to create visibility around innovative achievements and strategic behaviors. When innovation results in recognition, that recognition will drive more innovation.
      </p>`,
    },
  ],
});

const SELECT_CONSTANTS = Object.freeze({
  MULTI_BENIFIT: [
    {
      keyIndex: 0,
      alt: endPoints.SELECT_SAVING_LOGO.ALT,
      image: endPoints.SELECT_SAVING_LOGO.URL,
      htmlData: `<h2 className="underline-left">Cashless corporate cafeteria solution<hr /> </h2>
      <p>With unlimited budget and unlimited team size, Zaggle’s custom deal booking will help you get great deals across your city.</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SELECT_PAYMENT_PROCESS_LOGO.URL,
      alt: endPoints.SELECT_PAYMENT_PROCESS_LOGO.ALT,
      htmlData: `<h2 className="underline-left">Payment processing solutions<hr />
      </h2>
      <p>Supporting pharma and logistic companies with Multi-site ofices , branches or retail stores to enhance payment processings and business operations.</p>`,
    },
  ],
});

const SAVE_CONSTANTS = Object.freeze({
  EXPENSE_MANAGEMENT: [
    {
      keyIndex: 0,
      alt: endPoints.SAVE_CAPTURE_LOGO.ALT,
      image: endPoints.SAVE_CAPTURE_LOGO.URL,
      htmlData: `<p>Capture accurate expense data<br /> from employees
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_AUTOMATE_LOGO.URL,
      alt: endPoints.SAVE_AUTOMATE_LOGO.ALT,
      htmlData: `<p>Automate your expense<br /> policy and approvals
      </p>`,
    },
    {
      keyIndex: 2,
      alt: endPoints.SAVE_INSTANT_LOGO.ALT,
      image: endPoints.SAVE_INSTANT_LOGO.URL,
      htmlData: `<p>Instant visiblity of spending<br /> and budgets
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.SAVE_CUTOFF_LOGO.URL,
      alt: endPoints.SAVE_CUTOFF_LOGO.ALT,
      htmlData: `<p>Cut off dates and reminders for<br /> reports and approvals 
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.SAVE_CONTINOUS_LOGO.URL,
      alt: endPoints.SAVE_CONTINOUS_LOGO.ALT,
      htmlData: `<p>Continuous sync to your<br /> accounting software
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.SAVE_HASSLEFREE_LOGO.URL,
      alt: endPoints.SAVE_HASSLEFREE_LOGO.ALT,
      htmlData: `<p>Hassle-free Reimbursements<br /> for every expense
      </p>`,
    },
  ],
  SAVE_FEATURE: [
    {
      keyIndex: 0,
      image: endPoints.SAVE_TRAVEL_EXPENSE.URL,
      alt: endPoints.SAVE_TRAVEL_EXPENSE.ALT,
      htmlData: `<h2 className="underline-left">Travel & Expense Management <hr /></h2>
      <p>T&E costs are the second most troublesome expense line item for businesses to control. So, move away from spreadsheets and paper receipts.<br /><br />Zaggle’s mobile T&E solution, can allow employees to submit their trips and expenses with ease. This ensures that companies gain completely visibility over travel and expense spends and, become 100% compliant, it also helps them to find opportunities to save money.
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_PREPAID_CARDS.URL,
      alt: endPoints.SAVE_PREPAID_CARDS.ALT,
      htmlData: `<h2 className="underline-left">Prepaid Cards for Business Expenses <hr /></h2>
      <p>Zaggle gives you the easiest and smartest platform to manage all your business expenses through VISA-powered Zaggle Cards.<br /><br />
        A simple alternative to corporate debit/credit cards and cash advances, Zaggle enables your employees to move from paper-heavy to paperless and cashless, while at the same time allowing businesses to track employee spends and sync all the data to their accounting systems with ease.
        </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.SAVE_PRETTY_CASH.URL,
      alt: endPoints.SAVE_PRETTY_CASH.ALT,
      htmlData: `<h2 className="underline-left">Petty Cash Management <hr /></h2>
      <p>Petty cash management can turn into a headache. Zaggle simplifies the whole process and helps businesses manage multiple branches from anywhere. Businesses have real-time visibility and control over branch-wise expenses.<br /><br />Zaggle automatically forwards all the data to the bookkeeping & ERP systems for accounting. This enables a streamlined paperless flow without any controlling peaks.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.SAVE_EMP_EXP_REMBURSEMENT.URL,
      alt: endPoints.SAVE_EMP_EXP_REMBURSEMENT.ALT,
      htmlData: `<h2 className="underline-left">Employee Expense Reimbursement <hr /></h2>
      <p>Zaggle improves employee satisfaction with faster reimbursements.<br /><br />
        By reducing employee reimbursement cycle time by two-thirds, Zaggle helps the businesses and employees save time and costs. Employees making purchases through cash or personal debit cards can simply take a photograph of the receipt and upload it onto the app. Zaggle takes care of the rest.
        </p>`,
    },
  ],
  SAFE_SECURE_SIMPLE: [
    {
      keyIndex: 0,
      image: endPoints.SAVE_QUICK_LOGO.URL,
      alt: endPoints.SAVE_QUICK_LOGO.ALT,
      htmlData: `<h4>Quick On-boarding</h4>
      <p>Add employees individually or upload .csv / xls file to on-board easily on our dashboard
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_ACCURATE_LOGO,
      alt: 'Accurate Data and and error-free',
      htmlData: `<h4>Accurate Data</h4>
      <p>As the data is digitized, there is no fear of lost receipts resulting in mapped data as per expense.
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.SAVE_ACCOUNT_LOGO.URL,
      alt: endPoints.SAVE_ACCOUNT_LOGO.ALT,
      htmlData: `<h4>Setup Account</h4>
      <p>Configure all company settings like spend limits, categories, approval, company policies, etc.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.SAVE_MANAGE_EXPENSE_LOGO.URL,
      alt: endPoints.SAVE_MANAGE_EXPENSE_LOGO.ALT,
      htmlData: `<h4>Manage Expenses</h4>
      <p>Fund, track and manage all the expenses at one place through our dashboard and mobile apps</p>`,
    },
  ],
});

const SAVEWIP_CONSTANTS = Object.freeze({
  EXPENSE_MANAGEMENT: [
    {
      keyIndex: 0,
      alt: endPoints.SAVE_AUTOMATE_LOGO.ALT,
      image: endPoints.SAVE_AUTOMATE_LOGO.URL,
      htmlData: `<p>Submit expense reports on-the-go<br />
      with Zaggle mobile app</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_CUTOFF_LOGO.URL,
      alt: endPoints.SAVE_CUTOFF_LOGO.ALT,
      htmlData: `<p>Real-time visibility & control with<br />
      intuitive dashboards</p>`,
    },
    {
      keyIndex: 2,
      alt: endPoints.SAVE_MIS_DASHBOARD.ALT,
      image: endPoints.SAVE_MIS_DASHBOARD.URL,
      htmlData: `<p>Seamless integrations with<br />
      accounting software</p>`,
    },
  ],
  SAVE_FEATURE: [
    {
      keyIndex: 0,
      image: endPoints.SAVE_EMP_EXP_REMBURSEMENT.URL,
      alt: endPoints.SAVE_EMP_EXP_REMBURSEMENT.ALT,
      htmlData: `<h2 className="underline-left">Submit your expenses on-the-go <hr /></h2>
      <p>Paper receipts are easily misplaced and can lead to incorrect entries. With Zaggle's advanced OCR (Optical Character Recognition) technology, your employees can click a picture of the receipt to submit expenses instantly.<br /><br />By extracting rich data from the paper receipts, Zaggle makes submitting expense reports a piece of cake for on-the-go employees.</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_EXPENSE_MANAGEMENT_DASHBOARD.URL,
      alt: endPoints.SAVE_EXPENSE_MANAGEMENT_DASHBOARD.ALT,
      htmlData: `<h2 className="underline-left">Real-time visibility and control with intuitive dashboards <hr /></h2>
      <p>Zaggle brings all employee expenses on one platform giving centralized visibility and control over company-wide expenditures, anytime, across any device.<br /><br />
      You can monitor, track, and approve expense reports in real-time. With access to real-time data, employee reimbursement cycle time is reduced by two-thirds.
        </p>`,
    },
  ],

  SHEET_FEATURE: [
    {
      keyIndex: 0,
      image: endPoints.SAVE_LANDING_PAGE.URL,
      alt: endPoints.SAVE_LANDING_PAGE.ALT,
      htmlData: `<h2 className="underline-left">Still using spreadsheets to manage expenses?<hr /></h2>
      <p>It's time you move away from time-consuming, error-prone spreadsheets and paper receipts for employee expense management.
      <br /><br />
      Zaggle Save is an all-in-one expense management software that helps track business spends, submit expenses instantly, manage compliance and find opportunities to save money.
      </p>`,
    },
  ],
  SAFE_SECURE_SIMPLE: [
    {
      keyIndex: 0,
      image: endPoints.SAVE_QUICK_LOGO.URL,
      alt: endPoints.SAVE_QUICK_LOGO.ALT,
      htmlData: `<h4>Quick On-boarding</h4>
      <p>Add employees individually or upload .csv / xls file to on-board easily on our dashboard
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.SAVE_ACCURATE_LOGO,
      alt: 'Accurate Data and and error-free',
      htmlData: `<h4>Accurate Data</h4>
      <p>As the data is digitized, there is no fear of lost receipts resulting in mapped data as per expense.
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.SAVE_ACCOUNT_LOGO.URL,
      alt: endPoints.SAVE_ACCOUNT_LOGO.ALT,
      htmlData: `<h4>Setup Account</h4>
      <p>Configure all company settings like spend limits, categories, approval, company policies, etc.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.SAVE_MANAGE_EXPENSE_LOGO.URL,
      alt: endPoints.SAVE_MANAGE_EXPENSE_LOGO.ALT,
      htmlData: `<h4>Manage Expenses</h4>
      <p>Fund, track and manage all the expenses at one place through our dashboard and mobile apps</p>`,
    },
  ],
});

const ABOUTUS_CONSTANTS = Object.freeze({
  DESCRIPTION: [
    {
      keyIndex: 0,
      header: 'About Us',
      htmlData: `<p>
      “Don’t find customers for your products; find products for your customers.” – Seth Godin <br /><br />
      Founded in 2011 by Raj N, a serial entrepreneur, and seed investor, Zaggle is a payments company with a focus on businesses and corporates. Zaggle designs proprietary tech platforms that connect corporate and group consumer requirements with merchants who have the best-suited solutions for them.
      <br /><br />
      Interestingly, the word ‘Zaggle’ stands as an antidote to ‘Haggle’ and when customers started searching for a solution that would enable them to interact with the merchants while bringing them savings and experiences seamlessly, providing for limitless choices and flexibility, Zaggle was born.
      <br /><br />
      We aspire to create unique experiences and savings for groups’ consumers by enabling payments and through innovative tech solutions. We endeavor to achieve this through the discipline of execution, innovation and rapid product development.
      <br /><br />
    </p>`,
    },
    {
      keyIndex: 1,
      header: 'Vision',
      htmlData: `<p>
      To become one of the most innovative payments solution company by accelerating the conversion of cash transactions to digital payments through mobile, cards and other digital formats thereby bringing convenience, speed, security & choice to customers.
      <br /><br />
    </p>`,
    },
    {
      keyIndex: 2,
      header: 'Mission',
      htmlData: `<p>
      Create, market and distribute innovative prepaid products that address the growing needs, desires and aspirations of Indian consumers & corporates.
    </p>`,
    },
  ],
  OUR_VALUES: [
    {
      keyIndex: 0,
      image: endPoints.ABOUTUS_AMITION_LOGO.URL,
      alt: endPoints.ABOUTUS_AMITION_LOGO.ALT,
      htmlData: `<h4>Ambition</h4>
      <p>We don't make any compromise and want to build the best possible service.</p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.ABOUTUS_SERVICE_LOGO.URL,
      alt: endPoints.ABOUTUS_SERVICE_LOGO.ALT,
      htmlData: `<h4>Service</h4>
      <p>
        We aim to provide the best service possible, from product to customer support.
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.ABOUTUS_SIMPLICITY_LOGO.URL,
      alt: endPoints.ABOUTUS_SIMPLICITY_LOGO.ALT,
      htmlData: `<h4>Simplicity</h4>
      <p>
        Our products must be simple and intuitive, centered on the user, without a user manual.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.ABOUTUS_EFFICIENCY_LOGO.URL,
      alt: endPoints.ABOUTUS_EFFICIENCY_LOGO.ALT,
      htmlData: `<h4>Efficiency</h4>
      <p>
        We must enable you to save time and money
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.ABOUTUS_TRANSPARENCY_LOGO.URL,
      alt: endPoints.ABOUTUS_TRANSPARENCY_LOGO.ALT,
      htmlData: `<h4>Transparency</h4>
      <p>
        Our prices are transparents, without any hidden fees. We answer to all your questions.
      </p>`,
    },
  ],
  POWER_OF_ZAGGLE: [
    {
      keyIndex: 0,
      image: endPoints.ABOUTUS_OFFICE.URL,
      alt: endPoints.ABOUTUS_OFFICE.ALT,
      htmlData: `<p className="line-height-23"><b>Ten </b><br />
      Offices
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.ABOUTUS_ZAGGLERS.URL,
      alt: endPoints.ABOUTUS_ZAGGLERS.ALT,
      htmlData: `<p className="line-height-23"><b>200+ </b><br />
      Zagglers
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.ABOUTUS_CORPORATE_CLIENT.URL,
      alt: endPoints.ABOUTUS_CORPORATE_CLIENT.ALT,
      htmlData: `<p className="line-height-23"><b> 3500+</b><br />
      Corporate Clients
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.ABOUTUS_MERCHANT.URL,
      alt: endPoints.ABOUTUS_MERCHANT.ALT,
      htmlData: `<p className="line-height-23"><b>8500+</b><br />
      Merchant Relationships
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.ABOUTUS_GIFTCARD.URL,
      alt: endPoints.ABOUTUS_GIFTCARD.ALT,
      htmlData: `<p className="line-height-23"><b>3.5 Million +</b><br />
      Gift Cards in the Market
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.ABOUTUS_ZAGGLE_PLATFORM.URL,
      alt: endPoints.ABOUTUS_ZAGGLE_PLATFORM.ALT,
      htmlData: `<p className="line-height-23"><b>2.5 Million</b><br />
      Users across Zaggle Platforms
      </p>`,
    },
  ],
  ZAGGLE_MAP: [
    {
      keyIndex: 0,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'gurgaon map-pointer',
      alt: 'Gurgaon',
      htmlData: `<p className="line-height-23"><b>Ten </b><br />
      Offices
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'kolkata map-pointer',
      alt: 'Kolkata',
      htmlData: `<p className="line-height-23"><b>200+ </b><br />
      Zagglers
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'mumbai map-pointer',
      alt: 'Mumbai',
      htmlData: `<p className="line-height-23"><b> 3500+</b><br />
      Customers
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'pune map-pointer',
      alt: 'Pune',
      htmlData: `<p className="line-height-23"><b>8500+</b><br />
      Merchant Relationships
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'hyderabad map-pointer',
      alt: 'Hyderabad',
      htmlData: `<p className="line-height-23"><b>3.5 Million +</b><br />
      Gift Cards in the Market
      </p>`,
    },
    {
      keyIndex: 6,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'ahmedabad map-pointer',
      alt: 'Ahmedabad',
      htmlData: `<p className="line-height-23"><b></b><br />
      </p>`,
    },
    {
      keyIndex: 7,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'bangalore map-pointer',
      alt: 'Bangalore',
      htmlData: `<p className="line-height-23"><b></b><br />
      </p>`,
    },
    {
      keyIndex: 8,
      image: endPoints.ABOUTUS_MAP_PIN,
      className: 'chennai map-pointer',
      alt: 'Chennai',
      htmlData: `<p className="line-height-23"><b></b><br />
      </p>`,
    },
  ],
});

const TEAM_CONSTANTS = Object.freeze({
  WHO_WE_ARE: [
    {
      keyIndex: 0,
      image: endPoints.TEAM_FOUNDER.URL,
      linkedin_id: endPoints.TEAM_FOUNDER_LINKEDIN,
      alt: endPoints.TEAM_FOUNDER.ALT,
      htmlHeader: `Raj N<br /><span>Founder & Chairman
      </span>`,
      htmlData: `<p>
      Raj N, Founder and Chairman of Zaggle, has over 20 years of business consulting experience. He founded Zaggle in 2011 as a network-agnostic payment platform on which merchants and consumers could seamlessly interact. A start-up evangelist, a strategist and a serial entrepreneur who previously worked with PricewaterhouseCoopers Pvt. Ltd. and eYantra, Raj has extensive experience in setting up a business, structuring it, driving the sales and scaling it to the next level. His deep management experience and broad leadership skills help him drive efficient growth. He is on the Board of Directors of Loyalty Reward 3, eYantra, SSL Ltd., Zaggle, and Privilege Corner.<br /><br />
      A key contributor to the Indian start-up ecosystem and a true visionary, he won the “Small Scale Entrepreneur of the Year” award in 2007. His futuristic outlook has been printed in magazines such as The Smart CEO, Business Today, Internet World and Outlook Business.<br /><br />
      A business graduate from NYU Stern School of Business, Raj has successfully led the company to over INR300 Crores valuation and another two companies to over INR150 Crore valuation.
      When he is not mentoring start-ups on the power of innovation, creativity and entrepreneurship, he enjoys spending personal time organic farming, watching comedy shows, playing golf, cricket and badminton.
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.TEAM_CEO.URL,
      linkedin_id: endPoints.TEAM_CEO_LINKEDIN,
      alt: endPoints.TEAM_CEO.ALT,
      htmlHeader: `Avinash Godkhindi <br /><span>MD & CEO
      </span>`,
      htmlData: `<p>
      Avinash Godkhindi is the Chief Executive Officer and Managing Director at Zaggle. With over 15 years of experience in international Fintech & payments, Avinash has been spearheading Zaggle’s growth since joining the company in 2012.  Having served successful tenures in 12 countries across five continents in companies such as ING Bank, Barclays, Citicorp, Misys International and NIIT Technologies, he has held various leadership roles in product, sales, marketing, strategy, technology and operations across digital payments, fintech and cash management businesses.<br /><br />
      During his tenure at Citibank, he was credited with the biggest credit card launch in India, the “Premier Miles Credit Card”.<br /><br />
      Avinash completed his MBA from the University of Chicago Booth School Of Business and is a fitness freak. When not in office, you would find him on the field playing cricket or football, or in the basketball court shooting a few balls. He is an avid reader and traveller, with wanderlust in his veins - to explore the far and unknown.
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.TEAM_VP_PROD.URL,
      linkedin_id: endPoints.TEAM_VP_PROD_LINKEDIN,
      alt: endPoints.TEAM_VP_PROD.ALT,
      htmlHeader: `Rajsekhar Gopisetti<br /><span>Vice President Products
      </span>`,
      htmlData: `<p>
      Rajsekhar Gopisetti is the Vice President (Products) at Zaggle. With over 20 years of experience in the fields of product development, project management, marketing, sales and strategy, he joined Zaggle in 2011. An innovator and a strategist, he has spearheaded the strategy and implementation road map for a range of prepaid product solutions for both corporates as well as consumers, crafting some of the most futuristic products in the digital space.<br /><br />
      Prior to Zaggle, Rajsekhar successfully led and launched multiple initiatives for eYantra, Times Online Money Ltd., and Philips India Ltd. He also created corporate online brand stores for diverse companies such as  TCS, HCL, Infosys, Capgemini and Dell. <br /><br />
      An alumnus of Indian Institute of Management (IIM) Lucknow, he is driven by his vision of helping build Zaggle into a world-class organization offering the best prepaid platforms.<br /><br />
      Rajsekhar is known for his gregarious personality both on the Zaggle floor as well as on the field playing his favourite sports. Outside work, he can be found organizing sports tournaments particularly badminton and bridge. A connoisseur of food and arts, he is the go-to person for restaurant recommendations in and around Hyderabad or reviews of the latest movies in town.
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.TEAM_CTO.URL,
      linkedin_id: endPoints.TEAM_CTO_LINKEDIN,
      alt: endPoints.TEAM_CTO.ALT,
      htmlHeader: `Sivakumar Vondivillu<br /><span>Chief Technology Officer
      </span>`,
      htmlData: `<p>
      Sivakumar Vondivillu is an Engineer from Thiagarajar College of Engineering, Madurai &amp; had done his Executive Program in Business Management from Indian Institute of Management, Calcutta.<br /><br />
      He is a passionate senior technology and engineering leader with versatile experience of 23+ years of excellence in engineering management and great hands-on software development. He is experienced in highly scalable and distributed architecture, analysis, design, development
      and managing software projects- predominantly in object oriented and internet/mobile technologies.<br /><br />
      In his previous role, he was heading the technology as Group CTO for People Combine group which runs various school brands including Oakridge International Schools. Prior to that, he was
      associated with brands like University (an EdTech startup), ibibo (eCommerce startup), Quark (desktop publishing software) etc. He was instrumental in building various products from
      scratch at ibibo. Goibibo and PayU are some of the products he helped building from scratch which become billion dollar companies later.<br /><br />
      In his ME time, Siva loves reading books, watching movies, listening Tamil songs. He is also a sports lover and likes to play badminton, tennis, also follows cricket avidly. He is passionate in
      Yoga for fitness and loves to talk &amp; preach about it to the interested audience.
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.TEAM_CFO.URL,
      linkedin_id: endPoints.TEAM_CFO_LINKEDIN,
      alt: endPoints.TEAM_CFO.ALT,
      htmlHeader: `Samar Vijay Pupala <br /><span>Chief Financial Officer
      </span>`,
      htmlData: `<p>
      Samar has a proven track record of over 25 years of experience in building Digital Businesses in Remittances (Remit2India), Payments (Direcpay), Mutual Funds, Equity, Taxation (Tax in 20) and Platform Sales. He likes to connect discrete and unconnected data points to achieve a different way of thinking.<br /><br />
      He has curated and driven the white labeled platform Business in Remittances for TimesofMoney and led the Regulatory Interface as its CFO with RBI, FATF, SEBI, Direct and Indirect Tax (GST) authorities and Regulators in the US, UK and Australia.<br /><br />
      He has served as Director on the Board of TimesofMoney Private Limited and was associated with Arthur Andersen, Timesgroup and Network International earlier.
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.TEAM_SALES.URL,
      linkedin_id: endPoints.TEAM_SALES_LINKEDIN,
      alt: endPoints.TEAM_SALES.ALT,
      htmlHeader: `Tushar Patil <br /><span>Regional Sales Head – West
      </span>`,
      htmlData: `<p>
      Tushar Patil is the Vice President –Sales at Zaggle. With over 18 years of successful experience in the banking and cement industry, he joined Zaggle in 2012 as the Regional Sales Head (West) and has been responsible for the promotion of digital payment instruments in Western India.<br /><br />
      He has in-depth expertise in channel & institutional sales, key account management, and relationship management while working in companies such as Lakshmi Cement, Binani Cement, ICICI Bank Ltd and Adecco. Being a Civil Engineer and an MBA (Marketing & Finance) from SIMB, Pune, Tushar firmly believes that Zaggle’s growth is based upon strong foundation of team work, perseverance, efficiency and persuasiveness. <br /><br />
      Outside the office, he spends his leisure time doing yoga and meditation. An avid traveller, he relishes every opportunity to explore a new place.
      </p>`,
    },
    {
      keyIndex: 6,
      image: endPoints.TEAM_HR.URL,
      linkedin_id: endPoints.TEAM_HR_LINKEDIN,
      alt: endPoints.TEAM_HR.ALT,
      htmlHeader: `Priti Mhatre<br /><span> Senior Manager – Human Resources
      </span>`,
      htmlData: `<p>
      Priti Mhatre is the Senior Manager – Human Resources at Zaggle. She heads pan India HR and strives to streamline every functions in HR department. <br /><br />
      She brings in 14+ years of work experience with 6+ years in Human Resources and rest in Operations and Client servicing, worked with companies like Intelenet Global Services, First Advantage & Ocwen Financial Solutions.<br /><br />
      Priti is a post graduate from Mumbai University and has done Masters in Human Resource Management from Symbiosis, Pune. <br /><br />
      When not in office, Priti likes to watch movies, hands on culinary art, listening to music, travelling & Zumba for fitness.
      </p>`,
    },
  ],
});

const CAREER_CONSTANTS = Object.freeze({
  BENIFITS: [
    {
      keyIndex: 0,
      image: endPoints.CAREER_INTRAPRENEUR.URL,
      alt: endPoints.CAREER_INTRAPRENEUR.ALT,
      htmlData: `<h4>Become an Intrapreneur</h4>
      <p>Shape our organisations by developing ways to provide more value to our customers. </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.CAREER_OPEN_COMMUNICATION.URL,
      alt: endPoints.CAREER_OPEN_COMMUNICATION.ALT,
      htmlData: `<h4>Open Communication </h4>
      <p>We want to build a culture around <br />authenticity and integrity. </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.CAREER_ZAGGLE_VISA.URL,
      alt: endPoints.CAREER_ZAGGLE_VISA.ALT,
      htmlData: `<h4>Zaggle VISA Card</h4>
      <p>We provide Zaggle Cards for your tax saving benefits and expenses. </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.CAREER_TEAM_SOCIAL.URL,
      alt: endPoints.CAREER_TEAM_SOCIAL.ALT,
      htmlData: `<h4>Team Socials</h4>
      <p>We gather for frequent lunch/dinners and conduct team activities for bonding.</p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.CAREER_BEST_GOODIES.URL,
      alt: endPoints.CAREER_BEST_GOODIES.ALT,
      htmlData: `<h4>Best Goodies</h4>
      <p>Everyone is provided with laptops, t-shirts, notepad, stickers and other necessities. </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.CAREER_REWARDS.URL,
      alt: endPoints.CAREER_REWARDS.ALT,
      htmlData: `<h4>Rewards and Recognition</h4>
      <p>Motivating employees by rewarding them for their work and performance.</p>`,
    },
  ],
  LOCATIONS_OPENINGS:
  [
    '',
    'Delhi',
    'Noida',
    'Mumbai',
    'Bangalore',
    'Hyderabad',
    'Ahemdabad',
  ],
  CATEGORY_OPENINGS:
  [
    '',
    'Products',
    'Tech',
    'Marketing',
    'Sales',
    'Human Resource Management',
    'Accounting and Finance',
    'Operations',
    'Strategic and Partnership',
    'Delivery',
  ],
  CAREER_OPENING_SALES: [
    {
      slug: 'dir-prod-edge',
      title: 'Director Product - EDGE, Hyderabad/Mumbai, India (Fulltime)',
      location: ['Hyderabad', 'Mumbai'],
      category: 'Products',
      description: `<b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Role and Responsibilities</b><br />
      <ol>
        <li>Strong experience on Payments Issuance side</li>
        <li>Should have lead a team of product managers earlier</li>
        <li>Thought leader in the space</li>
        <li>Scaled products over a period of time</li>
        <li>Cross functional experience and managing interaction with various teams.</li>
        <li>Should have led a team of 10+</li>
        <li>Experience in Agile methodology for product development</li>
        <li>Take Zaggle to a leadership position in the Payments Fintech space in India and Globally</li>
        <li>Draw up a product vision for Payments</li>
        <li>Drive the product along with sales to desired Revenue and Profit</li>
        <li>Participate in various forums all over the world</li>
        <li>Recruit, lead, train the team desired, to achieve the outcome</li>
        <li>Ensuring 100% customer satisfaction</li>
        <li>Prioritizing product feature rollout</li>
        <li>Ensure training material for the Sales and product team</li>
        <li>Interactions with various department leaders and the management for desired outcome</li>
        <li>Implement OKR</li>
        <li>Work with Operations and customer service to ensure product deliverables are met</li>
        <li>Coordinate with Marketing to help further product awareness and brand salience</li>
        <li>MBA from top tier business school</li>
        <li>Problem solving skills is a must</li>
        <li>Extremely good communication skills</li>
        <li>7+ years overall in Payments and Issuance</li>
        <li>Should have worked in a B2B company though not essential</li>
      </ol>
      <b>Experience</b><br />
      <p>7+ years overall in Payments and Issuance</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'business-head-save',
      title: 'Business Head – Save (Expense Management), Mumbai/Delhi/Hyderabad, India(Fulltime)',
      location: ['Mumbai', 'Delhi', 'Hyderabad'],
      category: 'Sales',
      description: `<b>Number of open Positions</b><br />
      <p>2</p>
      <b>Role and Responsibilities</b><br />
      <ol>
        <li>Embrace the company’s digital first philosophy to build the Save (Expense management & Reimbursements) business as India’s best SaaS based expense management platform in the next 12-18 months</li>
        <li>Own and execute a clearly defined product road map for Save, roadmap would be signed off by the senior management</li>
        <li>Complete end to end P&L responsibility for the Save business</li>
        <li>Work closely with Head of Engineering/Technology/Sales & Customer Service stakeholders to ensure efficient implementation, product enhancement and streamline delivery.</li>
        <li>Own the OKRs and publish metrics to rest of the senior management, measure the progress of the Save business on monthly basis.</li>
        <li>Build a robust lead pipeline of business customers to drive platform usage and SaaS revenu</li>
        <li>Demonstrate thought leadership at multiple domestic and international online and offline forums to engage with prospects, media, users and CFO community at large</li>
        <li>Build a strong inside sales team to drive the downloads and platform sales</li>
        <li>Lead and close multiple partnerships with HRMS companies, Accounting software companies, Travel companies, Banks, Card associations etc. like to exponentially drive the growth of the Save platform</li>
        <li>Meet/e-meet customers multiple times in a week to understand their pain points and possible opportunities.</li>
        <li>Own the customer experience of both platform users as well as the business customers and measure improvement of this on a monthly basis</li>
        <li>Lead customer product/sales demos and take contract negotiations to closure</li>
      </ol>
      <b>Age Group</b><br />
      <p>30-33 years</p>
      <b>Experience</b><br />
      <p>About 10-12 years’ experience in technology companies/enterprise sales out of which at least 5 years are spent leading the business and latest experience of minimum 3 years in a leadership role with a SaaS company</p>
      <b>Skill Sets</b><br />
      <ol>
        <li>Strong understanding and experience in building SaaS platforms</li>
        <li>High degree of comfort with technology and latest changes in the tech space</li>
        <li>Native with social media and digital sales & marketing</li>
        <li>Demonstrated leadership ability in building and nurturing high performance teams</li>
        <li>Strategic and analytical mind-set with demonstrated ability to simplify complex concepts and articulate uniquely differentiated value propositions to both technical and business audiences</li>
        <li>Ability to work in a fast paced environment with a high degree of comfort with ambiguity</li>
        <li>High aptitude, good with numbers, strong communicating, especially listening skills, presentation skills, excellent MS-Office skills, ability to grasp new ideas and concepts quickly, good combination of hard & smart worke</li>
        <li>Work independently with minimum supervision, capable of taking calculated risks and strong decision making ability</li>
        <li>Experience and ability to build, constantly fine tune and execute a business plan, good understanding and experience of managing P &Ls</li>
        <li>High degree of ownership, perseverance and a go getter attitude</li>
        <li>Willingness to travel for up to 30% of the time</li>
      </ol>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'react-js-developer',
      title: 'Software Engineer/Senior Software Engineer – Front End Developer – React JS.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>4</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for Software Developers to build and implement software programs. You will work with other Developers and Product Managers throughout the Software Development Life Cycle.</p>
      <p>In this role, you should be a team player with a keen eye for detail and problem-solving skills. You would be a go-getter and do not wait for instructions. You would jump onto the product pipeline, work with designers and product managers to get the requirements, work with backend developer to get API signatures, integrate your code with APIs, help QA person to test your feature and get it live on production</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li>Produce clean, efficient code based on specifications </li>
        <li>Integrate software components and third-party programs </li>
        <li>Verify and deploy programs and systems </li>
        <li>Troubleshoot, debug and upgrade existing software </li>
        <li>Gather and evaluate user feedback </li>
        <li>Recommend and execute improvements </li>
        <li>Ensure highest standard of performance, quality, and responsiveness of the applications </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
       <li> Overall experience of 3-7 years as UI Developer and 2-3 years as UI Lead Developer. </li>
       <li> 1-2 years of experience working with React JS and other advanced JavaScript libraries and frameworks. </li>
       <li> Ability to understand business requirements and translate them into technical requirements. </li>
       <li> Strong software engineering skills with the proven ability to build, deploy, and maintain a scalable codebase. </li>
       <li> Experience working with remote data using RESTful APIs and JSON. </li>
       <li> Strong understanding of development tools and technologies like ES6, Redux, Immutable, JSX Components, Bootstrap, HTML, CSS, Git, NPM, Express. </li>
       <li> Strong understanding of any build tool like Webpack, Babel, Gulp or similar. </li>
       <li> Strong affinity for benchmarking and performance optimisation. </li>
       <li> Experience deploying applications to cloud and setting up CI/CD is a plus. </li>
       <li> Experience building container images using tools like Docker is a plus. </li>
       <li> Ability to learn new languages and technologies. </li>
       <li> B.E/B.Tech in Computer Science, Engineering or a related field.</li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <p>Overall 3 -7 years of experience.</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'ruby-on-rails-developer',
      title: 'Software Engineer/Senior Software Engineer – Back End Developer – Ruby on Rails.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>4</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for Software Developers to build and implement software programs. You will work with other Developers and Product Managers throughout the Software Development Life Cycle.</p>
      <p>In this role, you should be a team player with a keen eye for detail and problem-solving skills. You would be a go-getter and do not wait for instructions. You would jump onto the product pipeline, work with designers and product managers to get the requirements, come up with API signatures, help QA person to test your feature and get it live on production</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
       <li> Produce clean, efficient code based on specifications </li>
       <li> Integrate software components and third-party programs </li>
       <li> Verify and deploy programs and systems </li>
       <li> Troubleshoot, debug and upgrade existing software </li>
       <li> Gather and evaluate user feedback </li>
       <li> Recommend and execute improvements </li>
       <li> Ensure highest standard of performance, quality, and responsiveness of the applications. </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
       <li> Over all 3-7 years of software engineering experience working with web applications and backend systems. </li>
       <li> At least 2 years of experience in production environment working with Ruby on Rails along with common libraries such as RSpec, Sidekiq, Redis. </li>
       <li> Strong understanding of concepts like MVC, ORM, and RESTful </li>
       <li> Strong understanding of Object Oriented Programming fundamentals. </li>
       <li> Strong understanding of server-side templating languages like SLIM and CSS pre-processors like SASS. </li>
       <li> Basic understanding of front-end technologies such as JavaScript, HTML5, and CSS3. </li>
       <li> Strong experience working with Linux like Operating Systems and shell environments like Bash, ZSH. </li>
       <li> Strong knowledge of integrating multiple databases into one system. </li>
       <li> Basic understanding of systems architecture and fundamental design principles behind a scalable web application. </li>
       <li> Ability to understand business requirements, derive database schemas and translate them into technical specifications and code. </li>
       <li> Strong hands on experience of Relation Databases like PostgreSQL, MySQL with ability of benchmarking and performance optimisation. </li>
       <li> Strong knowledge of any NoSQL database like MongoDB. </li>
       <li> Strong experience practicing TDD and writing test cases to achieve highest code coverage. </li>
       <li> Experience working with search engines like Elasticsearch, Solr is a plus. </li>
       <li> Experience integrating third party software and payment gateways is a plus. </li>
       <li> Experience deploying applications to cloud and setting up CI/CD is a plus. </li>
       <li> Experience building container images using tools like Docker is a plus. </li>
       <li> Experience with any popular JavaScript frameworks like React JS, Angular JS is a plus. </li>
       <li> Ability to learn new languages and technologies. </li>
       <li> B.E/B.Tech in Computer Science, Engineering or a related field. </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <p>Overall 3 -7 years of experience.</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'dev-ops-engineer',
      title: 'Dev Ops Engineer.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for Senior DevOps engineers to build and automate software development processes for our SaaS applications. You will work with other Developers and Product Managers throughout the Software Development Life Cycle.</p>
      <p>In this role, you should be a team player with a keen eye for detail and problem-solving skills. You would be a go-getter and do not wait for instructions. You would jump onto the current development pipeline, understand the nuances of it, find the gaps, come up with solutions and implement automation quickly. Have a keen eye on the key metrics of the infrastructure, set up alerting and monitoring systems and handle scalability and availability issues to ensure always-on sub-second responses from the applications</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Understanding DevOps requirements and project KPIs </li>
        <li> Implementing various development, testing, automation tools, and IT infrastructure </li>
        <li> Setting up tools and required infrastructure </li>
        <li> Defining and setting development, test, release, update, and support processes for DevOps operation </li>
        <li> Encouraging and building automated processes wherever possible </li>
        <li> Identifying and deploying cybersecurity measures by continuously performing vulnerability assessment and risk management </li>
        <li> Incidence management and root cause analysis </li>
        <li> Selecting and deploying appropriate CI/CD tools </li>
        <li> Strive for continuous improvement and build continuous integration, continuous development, and constant deployment pipeline (CI/CD Pipeline) </li>
        <li> Mentoring and guiding the team members </li>
        <li> Setting up logging, effective monitoring and alerting systems </li>
        <li> Setting up the process to act upon any alerts, categorization and SLAs for fixing the issues within SLAs </li>
        <li> Managing periodic reporting on the progress to the management and the customer </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> At least 6 years of DevOps experience in cloud infrastructure like AWS, Azure etc, especially AWS </li>
        <li> Experience in setting up Micro Services based application and scaling these applications </li>
        <li> Experience working on Linux based infrastructure </li>
        <li> Excellent understanding of Ruby, Python, Perl, and Java </li>
        <li> Configuration and managing databases such as MySQL, Mongo and other Big Data databases </li>
        <li> Excellent troubleshooting </li>
        <li> Working knowledge of various tools, open-source technologies, and cloud services </li>
        <li> Awareness of critical concepts in DevOps and Agile principles </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <p>At least 6 years of experience.</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'qa-engineer-manual-testing',
      title: 'QA Engineer (For Manual Testing).',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>2</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for a QA Tester to assess software quality through Manual Testing. You will be responsible for finding and reporting bugs and glitches.</p>
      <p>In this role, you should have a keen eye for detail and excellent communication skills. If you are also competent in executing test cases and are passionate about quality, we’d like to meet you.</p>
      <p>Ultimately, you will ensure that our products, applications and systems work correctly.</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Review and analyze system specifications </li>
        <li> Collaborate with QA Engineers to develop effective strategies and test plans </li>
        <li> Execute test cases (manual or automated) and analyze results </li>
        <li> Create logs to document testing phases and defects </li>
        <li> Report bugs and errors to development teams </li>
        <li> Help troubleshoot issues </li>
        <li> Conduct post-release/ post-implementation testing </li>
        <li> Work with cross-functional teams to ensure quality throughout the software development lifecycle </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> Proven experience as a Quality Assurance Tester or similar role </li>
        <li> Experience in project management and QA methodology </li>
        <li> <b>Experience in Mobile App Testing a must.</b> </li>
        <li> Familiarity with Agile frameworks and regression testing is a plus </li>
        <li> Ability to document and troubleshoot errors </li>
        <li> Working knowledge of test management software (e.g. qTest, Zephyr) and SQL </li>
        <li> Excellent communication skills </li>
        <li> Attention to detail </li>
        <li> Analytical mind and problem-solving aptitude </li>
        <li> Strong organizational skills </li>
        <li> BSc/BA/B.Tech in Computer Science, Engineering or a related field </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <p>3 -7+ years of experience.</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'qa-automation-engineer',
      title: 'QA Automation Engineer.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>2</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for a QA Tester to assess software quality through Automation testing. You will be responsible for finding and reporting bugs and glitches.</p>
      <p>In this role, you should have a keen eye for detail and excellent communication skills. If you are also competent in executing test cases and are passionate about quality, we’d like to meet you.</p>
      <p>Ultimately, you will ensure that our products, applications and systems work correctly.</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Design and Execution of Test cases Using Selenium Webdriver and TestNG and mobile testing frameworks like Appium or Espresso </li>
        <li> Knowledge on Data Driven Testing and Cross Browser Testing. </li>
        <li> Maintaining existing tests scripts/regression suites. </li>
        <li> Attending Agile meetings (Daily scrum meeting/Sprint planning/Backlog refinement) on assigned projects. </li>
        <li> Analyzing the Test Results and Reporting Defects / Observations on day to day basis. </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> Proven experience as a Quality Assurance Tester or similar role </li>
        <li> Experience in project management and QA methodology </li>
        <li> Experience in Mobile App Testing a must. </li>
        <li> Familiarity with Agile frameworks and regression testing is a plus </li>
        <li> Ability to document and troubleshoot errors </li>
        <li> Working knowledge of test management software (e.g. qTest, Zephyr) and SQL </li>
        <li> Knowledge on STLC. </li>
        <li> Knowledge in Java Programming. </li>
        <li> Knowledge in Selenium Tools such as Selenium WebDriver and Selenium Grid. </li>
        <li> Excellent communication skills </li>
        <li> Attention to detail </li>
        <li> Analytical mind and problem-solving aptitude </li>
        <li> Strong organizational skills </li>
        <li> BSc/BA/B.Tech in Computer Science, Engineering or a related field </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <p>3 -7+ years of experience.</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'ui-ux-designer',
      title: 'UI/UX Designer.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for a creative Visual Designer to shape and own the user interface design of our products with an experience of 4-8 years.</p>
      <p>For this role, you will collaborate with a cross-functional team, including designers, engineers, and product managers to ensure our branding is consistent and appealing. If you have the ability to convey messages and information through illustrations, graphics, presentations, and patterns and much more creative digital agency kind of work we’d like to meet you.</p>
      <p>Ultimately, you will design aesthetically-pleasing products that capture our brand and engage our audiences.</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Collaborate with internal teams to define user interface requirements </li>
        <li> Combine various colors, shapes and typography fonts to improve user experience </li>
        <li> Use visual design software to refine illustrations </li>
        <li> Concentrating more on the UX part as well to get a good user experience in the products while interacting with them. </li>
        <li> Apply sketching techniques, like gradients and contrasts to enhance digital images </li>
        <li> Present rough drafts to product managers and/or key stakeholders to gain approval </li>
        <li> Develop prototypes and models to use in various products to maximize aesthetic consistency </li>
        <li> Brainstorm new ideas, layouts, and graphics </li>
        <li> Stay up-to-date with design application changes and industry developments </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> Proven work experience as a Sr.Visual Designer, Sr.UI/UX Designer or similar role </li>
        <li> Portfolio of related works (e.g. logos, animations, and graphics) </li>
        <li> Hands-on experience with image editing, digital sketching & prototyping software like XD, Invision, Photoshop, Indesign and Adobe Illustrator. </li>
        <li> Strong aesthetic skills with the ability to combine various colors, fonts and layouts </li>
        <li> Ability to meet deadlines while working on team projects </li>
        <li> Attention to proper UX flow(requirement gathering, research, sketching, data arrangement, screens flow, low-fidelity prototype & Hi-fidelity prototype) and visual details. </li>
      </ul>
      <b>Skill Set</b><br /><br />
      <ol>
        <li> Proven work experience as a Sr/Lead Visual Designer, Sr.UI/UX Designer or similar role/ Working experience in digital agency is a must. </li>
        <li> Excellent Communication Skill </li>
        <li> If you have a fine arts, Visual Arts or relevant qualification, thats great. </li>
        <li> Should have Strong portfolio to demonstrate the work that you have done till now and your sense of design. </li>
      </ol>
      <b>Tools</b><br /><br />
      <ul>
        <li> Adobe Photoshop </li>
        <li> Adobe Illustrator </li>
        <li> Adobe XD </li>
        <li> Invision </li>
        <li> After Effects </li>
        <li> Tools like Balsamiq, sketch, etc. </li>
        <li> Powerpoint, Excel, Word is preferred </li>
      </ul>
      <b>What we look for</b><br /><br />
      <ol>
        <li> Creativity along with a thorough knowledge of ux research, colour theory, typography, and design principles and standards. </li>
        <li> Good to have Illustrator skills to translate ideas and metaphors to a visual storyboarding. </li>
        <li> Can understand UI wireframes and effectively convert them into informative and visually communicative screens. </li>
        <li> Work within brand guidelines to create layouts that reinforce a brands style or voice through its visual touch points. </li>
        <li> Should have experience in designing for different media - Print, web, mobile, motion graphics and video. </li>
        <li> Should be a keen self learner and willing to learn the new advancements in the field of visual design </li>
      </ol>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <ul>
        <li>Overall 4-8 years experience. </li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'engineering-manager',
      title: 'Engineering Manager.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>2</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for a seasoned Senior Engineering leader to build our suite of cutting-edge SaaS products.</p>
      <p>In this role, you will closely work with CTO, a team of highly talented software engineers and Product Managers throughout the Software Development Life Cycle.  You would be a go-getter and do not wait for instructions.</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Serve as the engineering leader and technical expert who can architect and design high performance and scalable products </li>
        <li> Answer questions and resolve issues brought forth by the engineering team members </li>
        <li> Create detailed engineering plans, processes, and procedures for engineering staff to use and abide by </li>
        <li> Propose and oversee budgets and timelines for engineering projects </li>
        <li> Check and confirm the accuracy of the work performed and the methods used by engineering staff </li>
        <li> Conduct various tests and quality assurance checks to verify the quality of completed projects </li>
        <li> Monitor and determine various staffing and training needs </li>
        <li> Hire the best engineers, train them when required, and keep them motivated </li>
        <li> Spearhead various research and development initiatives to identify opportunities for new projects and improved processes </li>
        <li> Communicate and collaborate with other managers and senior management team </li>
        <li> Prepare and deliver various engineering-related presentations, both internally and externally </li>
        <li> Solve engineering problems, debug complex issues, automate development pipeline, roll-up sleeves to write and review code, set up Dev-Ops processes, liaison with third party service providers to ensure our system is highly secured and compliant with regulatory requirements. </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> Minimum of a bachelor’s degree in engineering </li>
        <li> Master’s degree in engineering management or business administration preferred </li>
        <li> Analytical and mathematical mind, capable of evaluating and solving various complex problems </li>
        <li> Leadership skills necessary to manage and develop a team </li>
        <li> Organizational competencies and project management skills to keep projects, processes, and the entire engineering team on track </li>
        <li> Self-motivated attitude with the ability to multitask and thrive in a timeline-driven environment </li>
        <li> Interpersonal communication skills with expertise in distilling complicated topics to a broader audience </li>
        <li> Ability to work individually or as part of a team </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <ul>
        <li> 10+ years of engineering experience, with at least 4+ years in a management role </li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'full-stack-developer',
      title: 'Full Stack Developer.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>3</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for Full Stack Software Developers to build and implement our products. You will work with other Developers and Product Managers throughout the Software Development Life Cycle.</p>
      <p>In this role, you should be a team player with a keen eye for detail and problem-solving skills. You would be a go-getter and do not wait for instructions. You would jump onto the product pipeline, work with designers and product managers to get the requirements, come up with API signatures, design and implement the backend and frontend programs, help QA person to test your feature and get it live on production</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Work with development teams and product managers to ideate software solutions </li>
        <li> Design client-side and server-side architecture </li>
        <li> Build the front-end of applications through appealing visual design </li>
        <li> Develop and manage well-functioning databases and applications </li>
        <li> Write effective APIs </li>
        <li> Test software to ensure responsiveness and efficiency </li>
        <li> Troubleshoot, debug and upgrade software </li>
        <li> Create security and data protection settings </li>
        <li> Build features and applications with a mobile responsive design </li>
        <li> Write technical documentation </li>
        <li> Work with data scientists and analysts to improve software </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> Proven experience as a Full Stack Developer or similar role </li>
        <li> Experience developing desktop and mobile applications </li>
        <li> Familiarity with common stacks </li>
        <li> Knowledge of multiple front-end languages and libraries (e.g. HTML/ CSS, JavaScript, XML, jQuery, ReactJs, VueJs, AngularJs) </li>
        <li> Knowledge of multiple back-end languages (e.g. C#, Java, Python) and JavaScript frameworks (e.g. Angular, React, Node.js) </li>
        <li> Familiarity with databases (e.g. MySQL, MongoDB), web servers (e.g. Apache) and UI/UX design </li>
        <li> Excellent communication and teamwork skills </li>
        <li> Great attention to detail </li>
        <li> Degree in Computer Science, Statistics or relevant field </li>
        <li> Strong experience practicing TDD and writing test cases to achieve highest code coverage. </li>
        <li> Experience working with search engines like Elasticsearch, Solr is a plus. </li>
        <li> Experience integrating third party software and payment gateways is a plus. </li>
        <li> Experience deploying applications to cloud and setting up CI/CD is a plus. </li>
        <li> Experience building container images using tools like Docker is a plus </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'solution-architect',
      title: 'Solution Architect.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Define the architectural patterns to be followed </li>
        <li> Given a business problem, come up with overall system architecture </li>
        <li> Help the team implement the software as per architectural vision </li>
        <li> Define the coding and testing guidelines and standards </li>
        <li> Ensure coding and testing follow those guidelines and standards </li>
        <li> Choose appropriate technology stack for a given problem </li>
        <li> Define the data model for each product and evolve the systems </li>
        <li> Define and implement devops practices </li>
        <li> Design scalability, availability, security and overall performance standards </li>
        <li> Implement all non-functional requirements on the cloud with the help of DevOps team </li>
        <li> Write POCs and also implement certain complex integrations or features periodically </li>
        <li> Keep learning newer technologies, tools and techniques and suggest and apply modern technologies </li>
        <li> Relook at the current systems and suggest migration to a newer architecture appropriately </li>
      </ol>
      <b>Technical Requirements</b><br /><br />
      <ul>
        <li> Strong Experience on Micro service architecture, API Design and Implementation, Designing and Implementation of Cloud Native Apps, Broad Technology expertise on Java, Ruby, JavaScript and Frameworks like RoR, SpringBoot, ReactJS/VueJS, NodeJS.  </li>
        <li> Strong expertise of Designing and Implementing highly scalable Applications using streaming platform like Kafka, Strong expertise on SQL (PostgresSQL or similar) and NoSQL (MongoDB, Cassandra etc) Data modelling and Implementation.</li>
        <li> Expertise on Containerisation using Docker, and Orchestration using Kubernetes / ECS etc.  </li>
        <li> Strong experience on designing and implementing Security architecture for Web and Mobile Applications, Create and Communicate Architecture Models and High Level Design, Documentation and governance technical standards with technical architects/engineering managers </li>
        <li> Define and execute Proof of Concepts (POCs), Experience on Architecture and Design governance in Agile delivery."</li>
      </ul>
      <b>Requirements</b><br /><br />
      <ol>
        <li> Team Handling required/Individual Contributor role – Must be a good team player to communicate and enforce architectural guidelines, patterns, coach, guide and teach engineers and team leaders. Mostly IC role and might need to lead couple of technical leads later </li>
      </ol>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'tech-lead',
      title: 'Tech Lead.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>2</p>
      <b>Job Description</b><br /><br />
      <p>We are looking for a senior backend developer who is an expert in languages like RoR, Java, .Net or any other object-oriented languages. Furthermore, they must be able to inspire and mentor others when the need arises. We are looking for someone never says I do not know how , or I have never done that before - rather a person that says how about we try this.</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Architecting and designing scalable backend systems </li>
        <li> Integration and development of various microservices </li>
        <li> Creating unit tests using RSpec </li>
        <li> Reviewing other developers code as well as suggesting improvements </li>
        <li> Algorithm development and general optimization </li>
        <li> Setting up CI/ CD pipelines </li>
        <li> Collaborating with various stakeholders including QA, DevOps, PMs and other developers </li>
        <li> At Least 5 years solid experience on Ruby on Rails, including at least one start to finish project where you were the lead developer or a primary contributor. </li>
        <li> Solid understanding of deploying and maintaining Rails apps within the AWS environment. </li>
        <li> Ability to set up workers and deploy across multiple instances. </li>
        <li> Git experience, some would say you are a git master. </li>
        <li> You were a good team player </li>
        <li> Collaborate with designers, product managers, and other software developers to deliver compelling user- facing products </li>
        <li> Lead teams of developers in architecting efficient and reusable systems that drive complex applications across the stack </li>
        <li> Create instrumentation, monitoring, and alerting tools to ensure availability/ scalability during peak traffic times and implement solutions to maximize uptime </li>
        <li> Identify and resolve performance and scalability issues </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> A strong drive and sense of ownership of the challenges we take on, coupled with a team- oriented, can- do attitude  </li>
        <li> Working knowledge of standard CS fundamentals (data structures, algorithms, complexity analysis) </li>
        <li> A professional proficiency in English </li>
        <li> A systematic debugging and problem solving methodology </li>
        <li> Minimum of four years of experience with Rails 5 </li>
        <li> Devops experience (chef/ jenkins etc.) - preferable </li>
        <li> Understanding of the mobile landscape and how they interact with Restful API s. </li>
        <li> Preferably have built your own Gem </li>
        <li> Integration of third party API s, scraping, heavy data processing. </li>
        <li> Attention to detail </li>
        <li> Analytical mind and problem-solving aptitude </li>
        <li> Strong organizational skills </li>
        <li> BSc/BA/B.Tech in Computer Science, Engineering or a related field </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'qa-lead',
      title: 'QA Lead.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Work closely with the product team which includes PM, Designers, Developers, and QA right from the inception of features. Design new and enhance existing test suites based on business requirements </li>
        <li> Execute the test cases and report relevant issues to the concerned stakeholders </li>
        <li> Own communication throughout the sprint/release cycle </li>
        <li> Own the quality of features and the delivery of the entire feature </li>
        <li> Design, implement & maintain functional test automation at different product layers, viz. service and UI layers </li>
        <li> Analyze the testing process, release cycle, testing tools & technologies and suggest improvements </li>
        <li> Work vertically on each feature to test the business logic on the server-side and the user experience and user flows on UI (Mobile Application) </li>
        <li> Test the features on all devices and form factors, Web, Android and iOS  </li>
        <li> Manage a small team of 3 to 4 QA engineers </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> At least 5 years of experience in professional testing and solid knowledge of the quality assurance techniques, testing concepts, methodologies, test management tools and software testing processes. Experience with Jira, Postman is highly desirable </li>
        <li> Hands-on in API testing techniques and tools </li>
        <li> Working knowledge of mobile testing </li>
        <li> Hands-on in test automation using any language(preferably JAVA, Kotlin). Experience with building tools like maven and gradle </li>
        <li> Familiarity and knowledge about CI/CD tools like Jenkins, gitlab, circleci </li>
        <li> Understanding of core business logic, algorithms, datasets and able to perform low-level System and Data Analysis </li>
        <li> Working knowledge of SCM (Git/SVN). Experience with open source automation libraries like Selenium, Rest Assured, Appium </li>
        <li> B.E/B.Tech (any relevant background) </li>
        <li> 5-8 years of overall experience. </li>
        <li> 1-2 years of people management experience. </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <b>Experience</b><br />
      <ul>
       <li>Overall 5-8 Years of Experience </li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'scrum-master',
      title: 'Scrum Master.',
      location: ['Hyderabad'],
      category: 'Tech',
      description: `
      <b>Number of Open Positions</b><br />
      <p>1</p>
      <b>Job Description</b><br /><br />
      <p>As a Scrum Master, you'll act as a servant leader for your team(s) by facilitating clear communication to management and to the team. Our Scrum Masters are open, approachable, collaborative, and enjoy working with passionate people. They're proactive in solving problems to help their team(s) succeed. The Scrum Master drives Agile and Lean frameworks that result in quality product delivery and continuous improvement. They embrace agility as a practice. The Scrum Master is responsible for removing impediments that hinder the team from reaching their goals and has a flexible approach that enables the team to rapidly respond to changes.</p>      
      <b>Role and Responsibilities</b><br /><br />
      <ol>
        <li> Collaborating, facilitating, and leading the scrum team to overcome obstacles and realize success throughout the life of each sprint </li>
        <li> Organize and facilitates the sprint planning meeting </li>
        <li> Facilitates daily stand-up meetings, demo, and decision-making processes to ensure quick inspection and proper use of adaptation process </li>
        <li> Planning and prioritization of sprints/releases </li>
        <li> Conduct scrum ceremonies as per sprint/release cadence - epic grooming, sprint planning, daily stand-ups, retrospectives, sprint demonstrations </li>
        <li> Sprint tracking, Daily, Weekly, monthly reporting </li>
        <li> Compliance and audit to keep a check on the accuracy of inputs on Jira </li>
        <li> Cross-team coordination and Issue resolution </li>
        <li> Champion continuous improvement activities to reduce waste and increase productivity; coach organization to conduct continuous improvement events </li>
        <li> Coach product owners in creation and maintenance of the product backlog, including empirical planning </li>
        <li> Excellent communication and written skills </li>
      </ol>
      <b>Requirements</b><br /><br />
      <ul>
        <li> BE/BTech degree or equivalent experience </li>
        <li> Expertise with Agile and Scrum frameworks and their application in Product Development and delivery organization </li>
        <li> Ability to coach and mentor </li>
        <li> Ability to collaborate with and influence people at various levels </li>
        <li> Sound understanding of Scaling framework such as LeSS and various other Agile frameworks such as Kanban, XP </li>
        <li> Ability to leverage skills from coaching, facilitation, conflict resolution and more to serve the team(s) </li>
        <li> Possess an executive presence and ability to coach multiple teams across the product </li>
      </ul>
      <b>Location</b><br />
      <p>Hyderabad, India { Full Time }</p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'client_support_data_admin_exec',
      title: 'Client Support & Data Administration Executive / Sr. Executive',
      location: ['Mumbai'],
      category: 'Operations',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About Role:</b><br />
      <ol>
        <li>People managing multiple corporate (B2B) which is a basic criteria.</li>
        <li>Interacting across all levels within the corporate & within her organisation for solutioning.</li>
        <li>She should be smart to get her work done across all levels</li>
        <li>Should be presentable with a reasonable communication.</li>
        <li>Should know MS office.</li>
        <li>Handling client support functionality + Timely submission of Weekly / Monthly / Quarterly / Annual report</li>
        <li>Coordination with Finance for CN</li>
        <li>Coordination with Card team for plough back of funds to dashboard.</li>
        <li>Coordination with KYC team</li>
        <li>Managing care issues / looping relevant stakeholders</li>
        <li>Once trained can handle multiple Key accounts in 3 to 4 months</li>
        <li>Should be capable enough to manage 35 to 40 clients & a user base in excess of 20000</li>
      </ol>
      <b>Desired Candidates Skills:</b>
      <ol>
        <li>3-7 yrs of experience.</li>
        <li>Graduate</li>
        <li>Good Communication Skills</li>
        <li>Good Knowledge of MS office & Data Management.</li>
        <li>Has worked in diversified role Client relation , operations & data administration</li>
        <li>Immediate joiner preferred</li>
        <li>Should be open to travel.</li>
        <li>Client managing, multiple corporate (B2B) accounts, which is a basic and mandatory criterion.</li>
        <li>Interacting across all levels within the corporate & within her organisation for solutioning.</li>
        <li>Should be smart to get her work done across all level</li>
        <li>Should be presentable with a reasonable communication.</li>
        <li>Should know MS office.</li>
        <li>Please look for candidates working in B2B environment KAM CRM</li>
        <li>IT / SAS/Banking / hotel industry</li>
        <li>Only B2B</li>
      </ol>
      <b>Location:</b> <span>Mumbai - Male / Female.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'vp_partnership',
      title: 'VP Partnerships',
      location: ['Mumbai'],
      category: 'Strategic and Partnership',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About Role:</b><br />
      <p>A young and energetic alliances and partnerships professional with proven track record of driving and executing strategic alliances with global brands & institutions.
        The candidate should be excited by interacting with CXO and leadership stakeholders and have an innate ability to gather market insights, nurture relationships and execute joint programs.
        The candidate should have a strong blend of business & people skills combined with strong EQ and IQ.
      </p>
      <b>Job Purpose:</b><br />
      <p>As VP-Partnerships, you will be responsible for forging strategic partnerships with Banks, FinTech firms and Mid-Large corporates to enable the exponential growth of our SAAS products at Zaggle.
        You will visualize solutions and liaise with Product and Tech teams towards implementation that create value for us and our partners
      </p>
      <b>Roles & Responsibilities:</b>
      <ul>
        <li>Design the overall partnership strategy and identify key partners across various dimensions, which are critical to the company’s growth and vision</li>
        <li>Lead and manage a team forging growth partnerships, VAS partnerships, Banking & FinTech partnerships</li>
        <li>Pitch our product, to Sr. Management/CXOs at prospective partners, along with overall business proposition and take charge of solutions rollout with partners</li>
        <li>Be responsible for growth and development initiatives across all partner segments and lead business metrics that would drive the business</li>
        <li>Work with internal product and engineering teams to create solutions-oriented towards our partners and detail out the commercial terms of the partnerships</li>
        <li>Manage P&L with partners and lead & optimize all top-line and bottom-line levers</li>
      </ul>
      <b>Desired Candidate should be:</b>
      <ul>
        <li>MBA from a Tier-1 institute and at least 10 years of experience in a Business Development and Strategic Partnerships role, preferably with a financial services/ FinTech / SAAS company</li>
        <li>Proficient in building high-performing teams</li>
        <li>Strong communication skills and analytical abilities to shape up business partnerships with financial institutions and corporates</li>
        <li>Demonstrated ability to lead and manage large, multiple projects with internal and external stakeholders</li>
        <li>Expertise in managing all aspects of a P&L</li>
      </ul>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'mangr_sr_mangr',
      title: 'Manager / Sr. Manager',
      location: ['Mumbai'],
      category: 'Strategic and Partnership',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>Job Profile:</b><br />
      <ul>
        <li>Identify and execute partnerships resulting in growth opportunities. Build growth and strategy for avenues outside to target right customer segment. </li>
        <li>Reach out to potential partners ranging from various Associations, Corporates, Reseller, Overseas Partnerships, Banking & NBFC,’s and Generic Partnerships. </li>
        <li>Develop and deliver a strong pipeline of strategic partners that are in line with business goals as well deliver the next level of growth for the Company. </li>
        <li>Plan approaches, pitches and own all business metrics and growth for the Partnerships line of business </li>
        <li>Assisting in drafting MOUs, contracts, partnership plans with respective partners </li>
        <li>Guide product management to deliver the right programs with these partners </li>
        <li>Building and maintaining relationships with key executives and decision makers in the partner’s organization, with a primary focus on business expansion </li>
        <li>Build a scale in business development by collaborating with internal stakeholders (product, operations, marketing and legal teams), closely working with the management team towards conceptualizing and building the right product strategies</li>
      </ul>
      <b>Skills:</b><br />
      <ul>
        <li>Minimum of 3-5 years of experience in developing new, strong B2B partnerships with proven sales record </li>
        <li>Proven track record of growing and scaling the B2B partnership channel for a company </li>
        <li>Ability to thoroughly analyze business products and value proposition and put these into strategic thinking towards alliance & partnerships strategies </li>
        <li>Data driven decision making, Excellent communication and negotiation skills and ability to deliver engaging presentations </li>
        <li>Skills allowing to self-manage and self-improve without a need of constant monitoring</li>
        <li>Previous experience of establishing well-functioning and effective B2B partnership across industries and - outside-the-box- of usual alliances</li>
      </ul>
      <b>Qualification:</b> <span>Graduate and above</span><br />
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'location_heads_sales',
      title: 'Location Heads - Sales East, West, North & South, India (Fulltime)',
      location: ['Mumbai', 'Bangalore', 'Noida', 'Hyderabad'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>4</p>
      <b>Job Role:</b><br />
      <ul>
        <li>Strategize Product, manpower, Distribution Mix to achieve business volumes with controlled Cost of Acquisition</li>
        <li>Identify key co-brand and tactical channel partners</li>
        <li>Build a strong distribution network for credit card for achieving greater market reach and penetration</li>
        <li>Strategize along with the product team on various digital marketing initiatives - “DIY” as well as “Assisted”</li>
        <li>Set up a centralized call centre to fulfil leads generated through Digital Marketing Initiatives.</li>
        <li>Lead business plan and performance management of channel partners, including development and execution of joint sales plans, local area marketing, staff coaching and recruitment.</li>
        <li>Cross-sell of various VAS product.</li>
      </ul>
      <b>Job Requirement:</b><br />
      <ul>
        <li>Experience in Sales Management & Business Development.</li>
        <li>Experience in Credit Card business preferred.</li>
        <li>Should be able to drive and work with a Team reporting.</li>
      </ul>
      <b>Eligibility:</b><br />
      <ul>
        <li>MBA with 15-20 years of experience</li>
      </ul>
      <b>Location:</b> <span>Bangalore, Mumbai, Hyderabad, Noida.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'sr_mngr_esm',
      title: 'Sr. Manager - BD (EMS) - Enterprise Sales Manager (ESM)',
      location: ['Mumbai', 'Bangalore', 'Noida'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>12</p>
      <b>Job Profile:</b><br />
      <p>A young and energetic sales professional with proven track record of successfully selling SaaS products across markets. A savvy professional who is comfortable meeting and exceeding targets and working under timelines.</p>
      <p>The person should be excited by selling into new markets, strategizing next strategy, negotiating complex deals and beating the competition in head-to-head opportunities. Responsible for Sales & Business Development for India other geographies going forward. The candidate should have a good mix of product and business acumen (have leaded both P&L and product metrics), ability to liase with CXOs of top global corporates with ease.</p>
      <b>Roles & Responsibility:</b><br />
      <ol>
        <li>Drive the EMS sales in India and abroad</li>
        <li>Own top-line sales targets for entire assigned territory</li>
        <li>Gather strategic market insights and share valuable customer inputs and share the same with Head of Product and others for continuous product improvement</li>
        <li>Meet/e-meet customers multiple times in a week to understand their pain points and possible opportunities.</li>
        <li>Lead customer product/sales demos and take contract negotiations to closure</li>
        <li>Coordinate with existing internal stakeholders such as product, delivery and customer success teams to ensure smooth relationships with enterprise accounts</li>
        <li>Attend events and thought leadership forums to generate leads by nurturing relationships with CXOs of enterprise accounts</li>
      </ol>
      <b>Competencies/Skills/Experience/Education</b>
      <ol>
        <li>Post-graduate in management (MBA or equivalent) from a reputed university/institution</li>
        <li>High degree of comfort with technology and latest changes in the tech space</li>
        <li>Native with social media, digital sales & marketing</li>
        <li>Analytical mind-set with demonstrated ability to simplify complex concepts and articulate uniquely differentiated value propositions to both technical and business audiences</li>
        <li>Ability to work in a fast-paced environment with a high degree of comfort with ambiguity</li>
        <li>Work independently with minimum supervision, capable of taking calculated risks and strong decision-making ability</li>
        <li>High degree of ownership, perseverance, and a go getter attitude</li>
        <li>Willingness to travel for up to 30% of the time</li>
      </ol>
      <b>Location:</b> <span>Bangalore, Mumbai, Noida.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'executive_sr_executive_save_propel',
      title: 'Executive/Sr. Executive ( Employee Benefit & Propel)',
      location: ['Mumbai'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>2</p>
      <b>Job Description - Sales Ops / Data Research / Sales intelligence:</b><br />
      <ol>
        <li>The work as Data Research will be varied, however the primary function will be to provide research support within Sales team</li>
        <li>Identifying prospects & potential opportunities, and able to understand growth trends in different industries.</li>
        <li>Data collection and profiling of companies by means of various resources - social media, web and any other mediums. Secondary research carried out by extensive research in demand of team.</li>
        <li>Data updates in CRM system, ensure CRM is updated at all given points of time.</li>
        <li>Ensuring all data is updated for all sources of leads, highlight in case of not updated data with the sales team.</li>
        <li>Working closely with Manager Inside Sales in relation to creating and extracting report performance wise.</li>
        <li>Skill set: - Sound knowledge of MS Excel and MS PowerPoint - Previous experience of using LinkedIn for research and databases is advantageous Able to work in a sales environment</li>
      </ol>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'sr_mngr_dsc',
      title: 'Senior Manager, Digital Sales Consultant, DSC (R&R)',
      location: ['Mumbai'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>10</p>
      <b>Responsibilities:</b><br />
      <b>Drive B2B sales with focus on global start-ups & SMEs for our Expense management product</b><br />
      <ol>
      <li>Achieving and exceeding sales targets</li>
        <ul>
          <li> Revenues, deal closures and accounts onboarded </li>
        </ul>
      <li>Building a healthy sales pipeline with qualified prospects</li>
        <ul>
          <li>Working on qualified leads from inside sales and digital marketing teams</li>
          <li>Lead generation (self-driven)- Tele-calling, Emailing, social media & more</li>
        </ul>
      <li>Proactive Sales funnel planning for meeting targets</li>
        <ul>
          <li>Researching prospects on platforms e.g., Google, LinkedIn, Email</li>
          <li>Leveraging one’s own database as well as provided databases to build sales pipeline for the Sales closing team</li>
          <li>Duly leveraging CRM to catalogue prospect & deal status</li>
        </ul>
      <li>Enabling Assisted Buying via a Consultative Sales approach</li>
        <ul>
          <li>Understanding client pain-points via focussed meetings</li>
          <li>Conducting Product Demos highlighting our solutions</li>
          <li>Conduct focussed workshops as part of sales nurturing strategy</li>
          <li>Scheduling Meetings & regular follow-ups</li>
        </ul>
      </ol>
      <b>Opportunity:</b><br />
      <ul>
        <li>Work in one of India’s fastest growing & profitable FinTech company</li>
        <li>Be groomed for global sales positions in the future (based on performance)</li>
        <li>Work with a truly motivated team of A-players with an aggressive growth mindset</li>
      </ul>
      <b>Eligibility Criteria:</b><br />
      <ul>
        <li>Graduation (minimum requirement); Post-Graduation (Preferred)</li>
        <li>Minimum 5 years of Sales Experience</li>
        <li>Prior B2B SaaS sales (or sales) experience</li>
        <li>Start-ups and SME (Small & Medium Enterprises) sales exposure preferred</li>
        <li>Exposure to FinTech or Expense management sales preferred (not mandatory)</li>
      </ul>
      <b>Soft skills:</b><br />
      <ul>
        <li>Ability to meet sales targets</li>
        <li>Above par communicate skills (verbal as well as written)</li>
        <li>Growth mindset with a passion for Tech</li>
      </ul>
      <b>Offer details:</b><br />
      <ul>
        <li><b>Designation:</b> Digital Sales Consultant, XPNS</li>
        <li><b>Office hours:</b> Mon-Fri 9:30am - 6:30pm</li>
        <li><b>Preferred Location:</b> Mumbai or Hyderabad</li>
      </ul>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'inside_sales_head',
      title: 'Inside Sales Head',
      location: ['Mumbai'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>Responsibilities:</b><br />
      <b><i>Lead a team of Inside Sales professionals to build a robust B2B sales pipeline for our Expense management product</i></b><br />
      <ol>
        <li>Leading a team of Inside sales professionals targeting accounts across global markets</li>
        <li>Meeting Inside Sales Targets across global markets - India, SEA, N. America</li>
        <li>Ensuring team operations for inside sales functions</li>
        <ul>
          <li>Scheduling Meetings for our Sales consultants & diligent follow-ups</li>
          <li>Sales Conversions for digital DIY leads</li>
          <li>Researching prospects on platforms such as Google, LinkedIn</li>
          <li>Leveraging one’s own database as well as provided databases to build sales pipeline for the Sales closing team</li>
        </ul>
        <li>Qualifying marketing generated leads for Digital Sales Consultants based on pre-defined criteria</li>
        <li>Lead Generation - Tele-calling, Emailing, social media reach-outs & more</li>
        <li>Exceeding team targets - # Calls, Reach-outs, Meeting setups, Leads qualified, etc.</li>
        <li>Sales funnel planning & maintenance duly catalogued in the CRM</li>
      </ol>
      <b>Opportunity:</b><br />
      <ul>
        <li>Work in one of India’s fastest growing & profitable FinTech company</li>
        <li>Be groomed for global sales positions in the future (based on performance)</li>
        <li>Work with a truly motivated team of A-players with an aggressive growth mindset</li>
      </ul>
      <b>Eligibility Criteria:</b><br />
      <ul>
        <li>Graduation (minimum requirement); post-graduation (preferred)</li>
        <li>Minimum 7 years of Inside Sales Experience</li>
        <li>Prior B2B SaaS inside sales (or sales) experience</li>
        <li>Start-ups and SMEs (Small & Medium Enterprises) sales exposure preferred</li>
        <li>Exposure to FinTech or Expense management sales preferred (not mandatory)</li>
      </ul>
      <b>Soft skills:</b><br />
      <ul>
        <li>Ability to meet sales targets</li>
        <li>Above par communicate skills (verbal as well as written)</li>
        <li>Growth mindset with a passion for Tech</li>
      </ul>
      <b>Offer details:</b><br />
      <ul>
        <li><b>Designation:</b> Inside Sales Head, Digital Sales, XPNS</li>
        <li><b>Office hours:</b> Mon-Fri 9:30am - 6:30pm</li>
        <li><b>Preferred Location:</b> Mumbai.</li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'ast_mngr_mngr',
      title: 'Assistant Manager / Manager',
      location: ['Mumbai', 'Hyderabad', 'Noida'],
      category: 'Operations',
      description: `
      <b>Number of Open Positions</b><br />
        <p>5</p>
      <b>Job Profile:</b><br />
      <p>A young and energetic customer success leader with proven track record of driving SaaS product customer relationships. A leader who can drive a global customer success team and exceed customer expectations.</p>
      <p>The candidate should be excited by interacting with clients while servicing them with Fintech SaaS products. An innate ability to gather constructive feedback, nurture relationships and issue resolutions within industry standard TATs. The candidate should have a strong blend of business & people skills combined with strong IQ and leadership to drive entire team to effectiveness.</p>
      <p>Known for a good mix of product and business acumen (have leaded both P&L and product metrics), building agile strategy & systems that adapt to ever-changing ecosystem, organizing great teams, and cultivating bias for action and data-driven decision making.</p>
      <b>Roles & Responsibility:</b><br />
      <ol>
        <li>Drive the EMS customer success vertical in India and abroad</li>
        <li>Meet/e-meet customers multiple times a week to understand their pain-points and endeavour resolution at source</li>
        <li>Define, optimize and meet customer lifetime value targets (LTV)</li>
        <li>Build and head a strong team of customer success managers, inbound customer ticketing and operations executives</li>
        <li>Maintain consistently high client satisfaction</li>
        <li>Leverage CRM, customer ticketing and other tools for maximizing team effectiveness</li>
        <li>Gather and provide valuable market intelligence to the business and product teams</li>
        <li>Meet targets of minimizing client churn rates (%)</li>
        <li>Imbue a culture of trust and openness conducive to build successful client relationships in the long run</li>
        <li>Ensure intangible success indicators such as client testimonials, customer advocacy and referrals are met to drive EMS team to success</li>
      </ol>
      <b>Competencies/Skills/Experience/Education</b>
      <ol>
        <li>Post-graduate in management (MBA or equivalent) from a reputed university/institution</li>
        <li>Ability to spearhead client relationships with CXOs of fortune 1000 companies</li>
        <li>Cross-sell and up-sell to existing clientele and meet renewals targets</li>
        <li>Strong understanding and experience in sustaining customer relationships in Fintech/SaaS ecosystem</li>
        <li>Seamlessly coordinate with internal stakeholders including sales, product and partnerships to gather and assimilate detailed client intel</li>
        <li>High degree of ownership, perseverance, and a go-getter attitude</li>
        <li>Willingness to travel for up to 30% of the time</li>
        <li>Work independently with minimum supervision, capable of taking calculated risks and strong decision-making ability</li>
        <li>Ability to work in a fast-paced environment with a high degree of comfort with ambiguity</li>
        <li>Strategic and analytical mind-set with demonstrated ability to simplify complex concepts and articulate value propositions to both technical and business audiences</li>
        <li>Demonstrated leadership ability in building and nurturing high performance teams</li>
      </ol>
      <b>Location:</b> <span>Hyderabad, Mumbai, Noida.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'pr_manager',
      title: 'PR Manager',
      location: ['Mumbai'],
      category: 'Strategic and Partnership',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>Job Profile:</b><br />
      <ul>
        <li>Managing Public Relations and Corporate Communication for Zaggle</li>
        <li>Working with PR agencies (creative and media planning) to execute campaigns.</li>
        <li>Creating and curating content for infographics, interviews, and bytes from the internal stakeholders.</li>
        <li>Creating and editing the content of communications for all internal media, including the company intranet, town hall, presentations, organizational emails, and more.</li>
        <li>Exploring content trends by regular market research and analysis.</li>
        <li>Generating awareness and keep, the internal stakeholders informed about the initiatives taking place in the organization through internal communication.</li>
        <li>Handling production of in-house magazine and client testimonials/mail</li>
        <li>Planning & executing events</li>
        <li>Participating in Industry Awards</li>
      </ul>
      <b>Skills:</b><br />
      <ul>
        <li>Minimum of 3-5 years of experience</li>
        <li>Proven track record of growing and scaling PR Image for a company</li>
        <li>Content Creation Ability</li>
        <li>Data driven decision making, Excellent communication and negotiation skills and ability to deliver engaging presentations</li>
        <li>Skills allowing to self-manage and self-improve without a need of constant monitoring</li>
      </ul>
      <b>Qualification:</b>
      <ul>
        <li>Graduate and above</li>
      </ul>
      <b>Role :- PR & Events.</b><br />
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'operation_manager_sales',
      title: 'Operation Manager (Sales)',
      location: ['Mumbai'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About us:</b>
      <p>Sales Performance is a crucial team within Zaggle and it is responsible to improve the effectiveness of the sales team, both individually and as a whole, in achieving the sales targets.
        To do this, multiple interdependent, operationalized sales processes are set in place.
      </p>
      <b>About the role:</b>
      <p>Zaggle is looking for a Sales Operations Manager to help support our sales team as we manage incredible growth and new vertical expansions.
        He/she will be responsible for assisting sales leadership in driving operational excellence for the company along with the day-to-day administration and operational tasks.
        This role is a high value-add business partner to the sales organization, enabling revenue growth and increasing sales productivity by providing effective methodologies, efficient processes, value-added information and sales tools.
      </p>
      <b>Key Responsibilities:</b><br />
      <ul>
        <li>Managing and maintaining sales data in CRM</li>
        <li>Recognizing, developing, and implementing process improvements within the Sales department</li>
        <li>Developing and maintaining daily, weekly, monthly and quarterly reports and Key Performance Indicators for the sales team</li>
        <li>Managing and maintaining sales process adherence with Sales Representatives</li>
        <li>Partnering with Sales Leaders to create and maintain sales forecasting models and data.</li>
        <li>Assisting the Sales Leaders with Pipeline and Opportunity inspection</li>
        <li>Creating and maintaining Sales department policies, procedures, training manuals, and sales-related resource material</li>
        <li>Partner with Sales and Marketing department to refine and manage lead qualification process, analyze and report on campaign performance with reporting and dashboards</li>
        <li>Assisting with the onboarding and training process of new Sales Representatives</li>
      </ul>
      <b>Mandatory requirement:</b><br />
      <ul>
        <li>MIS creation and management</li>
        <li>Excellent verbal & written communication</li>
        <li>Business analytics to analyse sales performance</li>
        <li>Lead and Sales journey in CRM. Need this person to monitor and streamline our sales process in CRM.</li>
        <li>Microsoft suite like Excel and PowerPoint</li>
        <li>Good written English</li>
        <li>Should be smart, pro-active and career oriented</li>
      </ul>
      <b>Qualifications and Core Competencies:</b>
      <ul>
        <li>2+ years of experience in Sales Operations</li>
        <li>Proficiency with Microsoft Office</li>
        <li>Ability to understand the strategic direction and goals of the Sales Department and support appropriate processes to facilitate achievement of business objectives.</li>
        <li>Ability to understand high-level sales strategies, translate them into system and process requirements and ensure local execution and business impact.</li>
        <li>Well-developed capabilities in problem-solving and crafting efficient processes.</li>
        <li>A result and success-oriented mentality, conveying a sense of urgency and driving issues to closure.</li>
        <li>An ability to initiate and build relationships with people in an open, friendly and accepting manner.</li>
        <li>An innate drive to innovate and optimize the use of available resources.</li>
        <li>Comfort with adapting and adjusting to multiple demands, shifting priorities, ambiguity, and rapid change.</li>
        <li>Bachelor’s degree required.</li>
      </ul>
      <b>Type:</b> <span>Full time, Mid-Entry level</span><br />
      <b>Job Type:</b> <span>Full-time, Mon to Fri (9:30am-6:30pm)</span><br />
      <b>Location:</b> <span>Andheri, Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'dir_sales_ems',
      title: 'Director Sales (EMS)',
      location: ['Mumbai'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>Job Profile:</b><br />
      <p>A seasoned sales leader with proven track record of successfully leading SaaS products for market expansion. A sales leader who can drive a global sales team while exceeding targets along key business metrics.</p>
      <p>The person should be excited by selling into new markets, strategizing next strategy, negotiating complex deals and beating the competition in head-to-head opportunities. Responsible for Sales & Business Development strategy, execution and overall scaling up revenues for a B2B, SaaS product for India, US and other geographies.</p>
      <p>The candidate would require a strong blend of skills in business strategy; domain understanding, technology value proposition, user-journey analysis and influencing in order to make effective sales.<br />The ideal candidate will be responsible for architecting and executing a sales strategy.</p>
      <p>Known for a good mix of product and business acumen (have leaded both P&L and product metrics), building agile strategy & systems that adapt to ever-changing ecosystem, organizing great teams, and cultivating bias for action and data-driven decision making.</p>
      <b>Roles & Responsibility:</b><br />
      <ol>
        <li>Drive the EMS sales in India and abroad</li>
        <li>Own and execute a clearly defined product road map along with Head of Products for EMS across segments - Enterprise, mid-market as well as SMB</li>
        <li>Gather strategic market insights and share valuable customer inputs and share the same with Head of Product and others for continuous product improvement</li>
        <li>Build a robust lead pipeline of business customers to drive platform usage and SaaS revenue</li>
        <li>Demonstrate thought leadership at multiple domestic and international online and offline forums to engage with prospects, media, users and CFO community at large</li>
        <li>Build a strong inside sales team to drive the downloads and platform sales</li>
        <li>Meet/e-meet customers multiple times in a week to understand their pain points and possible opportunities</li>
        <li>Lead customer product/sales demos and take contract negotiations to closure</li>
      </ol>
      <b>Competencies/Skills/Experience/Education</b>
      <ol>
        <li>Strong understanding and experience in building SaaS platforms</li>
        <li>High degree of comfort with technology and latest changes in the tech space</li>
        <li>Native with social media, digital sales & marketing</li>
        <li>Demonstrated leadership ability in building and nurturing high performance teams</li>
        <li>Strategic and analytical mind-set with demonstrated ability to simplify complex concepts and articulate uniquely differentiated value propositions to both technical and business audiences</li>
        <li>Ability to work in a fast-paced environment with a high degree of comfort with ambiguity</li>
        <li>Work independently with minimum supervision, capable of taking calculated risks and strong decision-making ability</li>
        <li>Experience and ability to build, constantly fine tune and execute a business plan</li>
        <li>High degree of ownership, perseverance, and a go getter attitude</li>
        <li>Willingness to travel for up to 30% of the time</li>
      </ol>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'psu_co_ordinator',
      title: 'PSU Coordinator',
      location: ['Ahemdabad'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>He/She will manage PSU Database & helps PSU Sales generating leads.</li>
        <li>He/She will map all new tenders, renewals & collate required documents from respective departments.</li>
        <li>He/She will submit Tenders on GEM, CPPP, E-Procure or any other Govt. Portal within the defined timeline.</li>
        <li>He/She will work closely with PSU Sales & take weekly update on all movement/updates.</li>
        <li>He/She will work on all PSU in Central India, generate leads & work on closures.</li>
        <li>He/She will do competition analysis & market intelligence.</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Bachelor’s Degree with minimum 2+ years of experience in Govt. liaising or managed Public Sector businesses.</li>
        <li>Prior Experience of Tender submission would be preferrable.</li>
        <li>Strong Communication skills required.</li>
        <li>Knowledge of MS office is mandatory</li>
      </ul>
      <b>Location:</b> <span>Ahemdabad.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'sr_mngr_psu',
      title: 'Sr. Manager - West / South / North & East',
      location: ['Mumbai', 'Hyderabad', 'Noida'],
      category: 'Sales',
      description: `
      <b>Number of Open Positions</b><br />
        <p>3</p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>He/She will generate opportunities through multiple avenues such as marketing events, networking & referral database.</li>
        <li>He/She will meet & creating strong relationship with KDM’s & manage PSU Tenders.</li>
        <li>He/She will ensure Tender Qualification & onboarding 2 new PSU Client every Quarter.</li>
        <li>He/She will ensure smooth execution & onboarding of PSU Client.</li>
        <li>He/She will ensure time payments.</li>
        <li>He/She should be able to do competition analysis & market intelligence.</li>
        <li>He/She must ensure all Tender renewal & secure business of all existing clients.</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Bachelor’s Degree with minimum 3+ years of experience in Sales & Business Development.</li>
        <li>Preferrable candidate having experience in managing Public Sector businesses.</li>
        <li>Strong Communication skills.</li>
        <li>Knowledge of MS office is mandatory.</li>
      </ul>
      <b>Location:</b> <span>Mumbai, Hyderabad, Noida.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'digital_dir',
      title: 'Digital Director',
      location: ['Mumbai'],
      category: 'Marketing',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About the Role:</b><br />
      <p>
        As the business and team grow and expand, we are in the lookout for a Performance Marketing Manager with strong paid media credentials who is determined to grow the business with us.
        You will be working very closely with the different product managers, for SEO, affiliates, display and social media.
      </p> 
      <p>
        We work in a very dynamic environment where change is the constant and new exciting projects come up all the time:
        you will need to be able to identify patterns and opportunities, think at scale and prioritise tasks by their impact on business goals
      </p>
      <p>
        This role reports to our VP - Marketing, with campaigns covering multiple products and solutions,
        your input will be key to get us to the next level of growth.
      </p>
      <b>Responsibility:</b><br />
      <ul>
        <li><b>Drive business growth</b></li>
        <ul>
          <li>Develop new campaigns for multiple products and solutions as we expand our product offering and the territories in which our services are offered.</li>
          <li>Develop and deliver effective, measurable, multi-channel marketing campaigns to support business strategy.</li>
          <li>Help us attract new customers, take market share, and increase revenue across key regions.</li>
          <li>Manage the local budget for marketing and communications.</li>
          <li>Track marketing performance and report on effectiveness and ROI.</li>
        </ul>
        <li><b>Promote and protect the brand</b></li>
        <ul>
          <li>Build awareness of the brand and increase customer loyalty.</li>
          <li>Work with cross-site teams and agencies to guarantee consistency, on-brand creative, and best practices across all markets and campaigns.</li>
        </ul>
        <li><b>Champion effective customer-focused marketing</b></li>
        <ul>
          <li>Stay in touch with customer needs and latest marketing trends </li>
          <li>Help our prospects and customers understand our products and services and achieve their goals.</li>
          <li>Work with our in-house subject matter expects to create content that positions us as thought leaders.</li>
        </ul>
        <li><b>Functional expertise</b></li>
        <ul>
          <li>A/B test ad copy and landing pages to drive optimal performance, while considering the behavioural nuances of our customers and prospective customers.</li>
          <li>Coming up with new, fresh ideas on processes and products, and on how to improve the company’s results.</li>
          <li>Consistently monitoring results against targets, in line with the budgeted spend.</li>
          <li>Keep up to date with current technologies and initiatives relevant to digital marketing.</li>
        </ul>
      </ul>
      <b>Summary of required experience & attributes</b><br/>
      <ul>
        <li>Results-driven, numeric and analytical - stays focused.</li>
        <li>Strong attention to detail while retaining the capacity to see the wider picture.</li>
        <li>Good communication skills to translate technical jargon and data into knowledge that is actionable for the wider team.</li>
        <li>Ability to identify patterns and opportunities, think at scale and prioritise tasks by impact on business goals.</li>
        <li>Adaptable self-starter with a ‘can-do, hands-on’ approach.</li>
        <li>Self-motivated individual with the ability to work autonomously and as part of team.</li>
        <li>Proactive, willing to learn and to voice and adopt new ideas.</li>
      </ul>
      <b>Experience/Qualifications:</b><br/>
      <ul>
        <li>10+ years’ broad business experience (ideally in marketing within the financial sector).</li>
        <li>Planned and delivered successful, high-profile, multi-channel campaigns, above and below the line, including (but not limited to):</li>
        <ul>
          <li>Press and outdoor</li>
          <li>Digital and social media</li>
          <li>Partnerships, sponsorship and events.</li>
        </ul>
        <li>Used customer insights to shape effective marketing and communications.</li>
        <li>Managed teams, projects, and budgets.</li>
        <li>Good knowledge of Excel and PowerPoint to analyse trends in search data and report back to the business.</li>
        <li>Highly numerate and able to easily interpret large portions of data to assess marketing campaigns </li>
        <li>Understanding the core KPI's and how the marketing channel mix works.</li>
      </ul>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'campaign_mngr',
      title: 'Campaigns Manager',
      location: ['Mumbai'],
      category: 'Marketing',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About the Role:</b><br />
      <span>This role has two main components:</span><br />
        <ol style="margin-bottom: 0px">
          <li>Developing and executing global multi-channel marketing campaigns. This involves coordinating their preparation, launch and run, and measuring their performance.</li>
          <li>Ensuring we support our receive partners through marketing campaigns.</li>
        </ol>
      <p>We work in a very dynamic environment where change is the constant and new exciting projects come up all the time: you will need to be able to identify patterns and opportunities, think at scale and prioritise tasks by their impact on business goals</p>
      <p>This role reports to the Digital Marketing Director, with campaigns covering multiple products and solutions, your input will be key to get us to the next level of growth.</p>
      <b>Responsibility:</b><br />
      <ul>
        <li>Manage overall digital marketing strategies involving SEO, SEM, PPC, leveraging social platforms</li>
        <li>Use campaign management tools, Web Analytics, CRM, Marketing Automation tools, LMS, SEO & Social Media</li>
        <li>Search Engine Optimization to increase organic traffic and leads</li>
        <li>Manage Google Analytics for goal set-up, funnels, report generation, website study, visitor analysis, social media tracking, Adwords tracking and various other tools</li>
        <li>Drive FB Business Manager and Google Ads Manager campaign consoles for digital acquisitions and increasing the lead funnel</li>
        <li>Manage the implementation, tracking and measurement of campaigns through analytics, on time and optimize them</li>
        <li>Actively test and analyze keywords, advertising copy, landing pages and positioning to increase ROI and drive sales volume through the paid search channel</li>
        <li>Provide status reports by collecting, analyzing web analytics data to obtain meaningful data and trends</li>
        <li>Stay abreast of new paid search engine marketing developments and opportunities in the SEM domain and incorporate into on-going campaign management</li>
        <li>Measure and report performance of all digital marketing campaigns and assess against goals (ROI and KPIs)</li>
      </ul>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'brand_mktg_mngr',
      title: 'Brand Marketing Manager',
      location: ['Mumbai'],
      category: 'Marketing',
      description: `
      <b>Number of Open Positions</b><br />
        <p>1</p>
      <b>About the Role:</b><br />
      <p>
        The Brand Marketing Director will be responsible for Zaggle's brand and communications strategy across all touchpoints.
        He/she will plan and lead an annual campaigns calendar, manage marketing budgets, ensure integration with stakeholders and guide the day-to-day activities of the wider brand marketing team as well as our creative agency to help promote Zaggle as a market leader.
      </p>
      <b>Responsibility:</b><br />
      <b><i>Content Management</i></b>
      <ul>
        <li>Lead the content marketing strategy, development, and implementation to generate awareness of Zaggle and educate, inspire and engage a variety of audiences.</li>
        <li>Create and deliver disruptive content in all formats (written, video, audio, etc) across owned and earned channels (including social media, website, blog, influencer program, and sponsored content) that is insight-driven, on brand, and drives results.</li>
        <li>Test, revise, and optimize content to help uncover the most successful approaches.</li>
        <li>Identify newsworthy, share-worthy content opportunities that resonate with target audiences.</li>
        <li>Use market and customer data to develop actionable content that will complement their experience with our product.</li>
        <li>Develop Zaggle’s customer stories platform through mining, collection, and creation of stories.</li>
        <li>Manage and coordinate contractors, freelancers, and influencers to flawlessly execute on the Zaggle content strategy.</li>
        <li>Research and keep a pulse on trends, issues, and topics that matter most to Zaggle’s key audiences around the world to develop content that will capture their attention.</li>
      </ul>
      <b><i>Analysis & Insight</i></b>
      <ul>
        <li>Working in collaboration with internal customers to set the insight and analytics agenda and co-create insights that shape both the definition of local strategies and their successful execution.</li>
        <li>Ensuring analytical & insight outputs have recommendations that are practically doable and have a clear line of sight to expected commercial outcomes, commonly conversion, retention, cost saving, incremental value, campaign ROI and cost to serve.</li>
        <li>Understanding what our customer segments truly value, how well we satisfy their needs and getting the organisation to understand and act on this.</li>
        <li>Working closely with the data team to ensure that we have the most appropriate data to support our ambition, including third party profile data, to support our business needs and making proactive recommendations for enhancements and new sources as necessary.</li>
      </ul>
      <b>Location:</b> <span>Mumbai.</span><br /><br />
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },

    {
      slug: 'implementation_mangr_delivery',
      title: 'Implementation Manager (Delivery)',
      location: [''],
      category: 'Delivery',
      description: `
      <b>Job Overview:</b>
      <p>The Zaggle Implementation is responsible for implementing Zaggle - Expense Management Solution.
        This is techno-functional role and involves fulfilling the roles of both - a Project Manager and an Implementation Manager.
        Implementation Manager will have the overall leadership responsibility of the project including project management, managing all the teams who join the project (depending on the services purchased by the client)
        e.g. technical consultants, operations team, engineering team, travel team as well managing the end-to-end functional aspects of the projects
        i.e. scoping and analyzing requirements, configurations, managing client project team validation support and training.
      </p>
      <b>Responsibility:</b><br />
      <ul>
        <li>Lead the overall project delivery and implement all the Zaggle services   purchased by the client.</li>
        <li>Manage multiple concurrent complex, global multi-phased implementation following Zaggle’s Deployment Methodology and guide the client though the various implementation phases.</li>
        <li>Conduct gap analysis and effectively gather the client’s business requirements and design creative design solutions for complex requirements.</li>
        <li>Effectively manage client expectations, drive client deliverables and exercise scope to ensure project completes schedule – from Kick-off through Go-Live.</li>
        <li>Effectively work and communicate with all stakeholders, C-Level sponsors and client projects teams.</li>
        <li>Communicate complex ideas and persuade clients to adopt the recommended solution based on best practices.</li>
        <li>Develop and maintain strong functional and technical product knowledge.</li>
        <li>Effectively conduct trainings and product demonstration calls with clients remotely.</li>
        <li>Provide consultative expertise to the client, guiding clients through key decisions and tradeoffs to maintain project scope and timeline.</li>
        <li>Regularly provide updates on client statuses and wherever required escalate issues while maintaining control of the project.</li>
        <li>Deliver on commitments including any project tracking systems and fulfilling administrative responsibilities while staying organized throughout the project.</li>
        <li>Deliver outstanding client service to achieve high implementation survey scores.</li>
        <li>Effectively contribute to Zaggle’s project methodology and document library.</li>
        <li>Meet or exceed deployment productivity and quality metrics.</li>
        <li>Effectively work with peers, other departments and management.</li>
        <li>Be aware of, and comply with, all corporate policies.</li>
      </ul>
      <h3>Qualifications:</h3>
      <b>Education, Experience & Training required:</b>
      <br />
      <ul>
        <li>Four years degree with Accounting or Information Systems emphasis a plus.</li>
        <li>Minimum of three years of experience in implementing financial or hosted applications.</li>
        <li>Minimum of two years of project management, consulting and/or software implementation experience.</li>
        <li>Experience with financial applications and knowledge of accounting processes.</li>
        <li>Full life-cycle financial system implementation experience</li>
        <li>Strong organizational skills and ability to deliver on commitments</li>
        <li>Experience in client-facing/service roles a must.</li>
        <li>Ability to pass a background check.</li>
      </ul>
      <b>Job Specific Specialized Knowledge & Skills:</b>
      <br />
      <ul>
        <li>Understanding of implementation methodologies and project management in a software company.</li>
        <li>Strong problem resolution skills – proven to engage and interact with internal teams to resolve client issues.</li>
        <li>Must be comfortable in a fast-paced, fluid, and ever-changing work environment and able to facilitate changes as situation requires</li>
        <li>Must possess effective presentation skills as well as excellent written and oral communications skills.</li>
        <li>Must possess the ability to work both strategically and tactically.</li>
        <li>Excellent organizational, planning skills and negotiation skills.</li>
        <li>Strong technical aptitude and ability to understand technical concepts quickly.</li>
        <li>Finance/Accounting experience.</li>
        <li>Ability to address and manage through ambiguous situations – assess situations, solve problems and make decisions.</li>
        <li>Ability to prioritize and manage workload to meet deadlines.</li>
        <li>Must be results, goal, and customer service orientated.</li>
      </ul>
      <b>Critical Performance Competencies:</b>
      <br />
      <ul>
        <li>Accountability</li>
        <li>Planning and Organization</li>
        <li>Listening</li>
        <li>Communication and Influence</li>
        <li>Personal/ Professional Effectiveness</li>
        <li>Business Acumen/Strategic Business Perspective</li>
        <li>Adaptability/ Flexibility</li>
        <li>Attention to Detail</li>
        <li>Change Management</li>
        <li>Decisiveness/Judgement</li>
        <li>Intelligence</li>
        <li>Tenacity</li>
      </ul>
      <b>Value Competencies:</b>
      <br/>
      <ul>
        <li>Displays leadership through innovation and walks an extra mile to create innovative solutions.</li>
        <li>Displays customer centric passion, empathy & responsibility to the customer.</li>
        <li>Displays excellence and relentless commitment in delivering solutions to customers.</li>
        <li>Displays compete transparency to the customer and takes ownership.</li>
        <li>Displays personal & corporate integrity</li>
        <li>Hires, develops & rewards great people</li>
      </ul>
      <b>Working Environment (where major activities are carried out):</b>
      <br/>
      <ul>
        <li>Indoors in a office or control room</li>
      </ul>
      <b>Working hours:</b>
      <br/>
      <ul>
        <li>45+ hours per week will be typically necessary to accomplish performance objectives and to provide satisfactory job presence and/or responsiveness.</li>
        <li>Flexibility in working hours may be required to meet client obligations.</li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'business_solutions_delivery',
      title: 'Business Solutions (Delivery)',
      location: [''],
      category: 'Delivery',
      description: `
      <b>About Zaggle:</b><br />
      <p>Zaggle is a B2B2C SaaS FinTech company digitizing spends to drive growth and unlock value through innovative and automated workflows.</p>
      <p>We are looking for a suitable candidate with great communication skills and an understanding of the FinTech/HRTech industry.</p>
      <p>As a presales manager you will work closely with various groups/departments such as Sales, Product development, marketing, and customer relations.</p>
      <p>Your primary job will be to understand customer needs and pitching Zaggle products as suitable solutions. You will also be required to actively observe customer behavior and predict future needs for product development.</p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>Responsible for interaction with clients and ideate large scale customized sustainable solutions</li>
        <li>Developing solutions and organizing, planning, creating & delivering compelling proof of concept demonstrations</li>
        <li>Perform gap analysis in the customer requirement and the product offering through consultation with Pre-Sales/Product teams.</li>
        <li>Solution strategy, demo data creations & Storyboarding</li>
        <li>Coordinate and actively follow-up with tech team on the customer requirements</li>
        <li>Strong cross-functional department management skills to liaison and close deals through Sales, Product and Delivery teams</li>
        <li>Work with Product Management to feedback on issues with current products and provide input around new products</li>
        <li>Ideate and produce RFPs and other proposals, including sales bids, to clients</li>
        <li>Able to understand business drivers and risks involved to the customer and to Zaggle</li>
        <li>Streamline sales pipeline by regularly monitoring the customers in the pipeline, gather their requirements, and help close the deals by providing proper solutioning.</li>
        <li>To structure and produce compelling sales proposals/commercial and technical documentation outlining the cost savings and business benefits to clients of using Zaggle’s proposition</li>
        <li>Provide technical solutions in a professional manner and to agreed timeframes</li>
        <li>Perform technical development for bespoke solutions as part of a design and development frame work</li>
        <li>Create and confidently deliver technical and business presentations internally and externally</li>
        <li>Provide accurate and timely management information, to include - activity reports, bid reviews, project forecasts, KPI’s</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Strong Technical knowledge coupled with consulting experience to develop tailored SaaS solutions for clients </li>
        <li>Ability to strategically problem solve by thinking outside of the box</li>
        <li>You have prior relevant experience in technical consulting</li>
        <li>Should have at least 5+ year of experience working in a SaaS firm catering to B2B/B2C/B2B2C customers </li>
        <li>Possess a degree in Computer Science, Engineering, or related fields.</li>
        <li>Solution-oriented analytical skills</li>
        <li>You have excellent interpersonal and communication skills and are adept at working with multiple stakeholders</li>
      </ul>
      <b>Preferred Skills:</b><br/>
        <p>IT Product Management, Jira, PowerPoint, Communication, Customer centric, Presales, Sales, B2B/ B2B2C SaaS.</p>
      <b>Equal Opportunity employer:</b><br />
      <p>
        We’re an equal opportunity employer. All applicants will be considered for employment without attention to race, color, religion, sex, sexual orientation, gender identity, national origin, veteran or disability status.
      </p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'prd_mangr_prds',
      title: 'Product Manager',
      location: [''],
      category: 'Products',
      description: `
      <b>About Zaggle:</b><br />
      <p>Zaggle is a B2B2C SaaS FinTech company digitizing spends to drive growth and unlock value through innovative and automated workflows.</p>
      <p>We are looking for a Product Manager to assist us take our EMS platform to the next level. You will be in-charge of bringing our brilliant teams together to establish a product strategy/ roadmap and collaborate with our engineering team to deliver it to the market. </p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>Develop a vision, strategy, and roadmap for the product. </li>
        <li>Work closely with marketing team and multiply reach of the product by 20x and support the digital onboarding experience.</li>
        <li>Think out of the box strategies to deliver world class experience to all user personas.</li>
        <li>Bring together our cross functional teams to turn great ideas into reality and delight our customers.</li>
        <li>Drive the evolution of the product by leading cross-functional team meetings.</li>
        <li>Determine product features based on market research and client requirements.</li>
        <li>Be the primary source of information both internally and externally regarding product capability now and in the future.</li>
        <li>Create the cost benefit analysis and identify driver impact for any feature to determine priority.</li>
        <li>Create and maintain product documentation including PRD/BRD/FRD’s. </li>
        <li>Create wireframes using Adobe or similar tools.</li>
        <li>Dissect large product feature ideas into bite size user stories</li>
        <li>Influence a cross-functional team of developers, design, and stakeholders to focus on the right things to build</li>
        <li>Become the product expert and be able to answer the toughest questions about how it works</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Bachelor's Degree with minimum 3+ years in software Product Management for a B2B/B2C startup. Preferably in a Fintech/HRTech space. </li>
        <li>Prior experience of digital onboarding platforms.</li>
        <li>Should have delivered products which have had adoptions in Scale at B2C or B2B in a short period of time, this is a mandatory requirement.</li>
        <li>Strong analytical and problem-solving skills with a customer service driven focus</li>
        <li>Ability to draw wireframe using Adobe or similar tools is a must</li>
        <li>Ability to pick up new concepts and technology quickly, including understanding complex details</li>
        <li>Experience working directly with Engineering teams, designers, stakeholders.</li>
        <li>Experience with Agile as Product Owner using KanBan and Scrum processes</li>
        <li>Technical depth and aptitude, including a solid understanding of web/mobile technologies, ROR, Node.js and API services is good to have but not mandatory.</li>
        <li>Good knowledge of project management software (Jira, Github)</li>
        <li>Highly motivated, energetic self-starter who is well organized and takes ownership</li>
        <li>Ability to question traditional/conventional practices and propose change</li>
      </ul>
      <b>Preferred Skills:</b><br/>
        <p>IT Product Management, Jira, API’s, Digital innovation, PRD, B2B/ B2B2C SaaS.</p>
      <b>Equal Opportunity Employer:</b><br />
      <p>
        We’re an equal opportunity employer. All applicants will be considered for employment without attention to race, color, religion, sex, sexual orientation, gender identity, national origin, veteran or disability status.
      </p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'sr_prd_mangr_prds',
      title: 'Senior Product Manager',
      location: [''],
      category: 'Products',
      description: `
      <b>About Zaggle:</b><br />
      <p>Zaggle is a B2B2C SaaS FinTech company digitizing spends to drive growth and unlock value through innovative and automated workflows.</p>
      <p>We are looking for a Senior Product Manager to assist us take our EMS platform to the next level. You will be in-charge of bringing our brilliant teams together to establish a product strategy/ roadmap and collaborate with our engineering team to deliver it to the market. </p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>Develop a vision, strategy, and roadmap for the product. </li>
        <li>Bring together our cross functional teams to turn great ideas into reality and delight our customers.</li>
        <li>Play the product owner role and work directly with the Engineering team to translate your roadmap into development plans.</li>
        <li>Drive the evolution of the product by leading cross-functional team meetings.</li>
        <li>Determine product features based on market research and client requirements.</li>
        <li>Be the primary source of information both internally and externally regarding product capability now and in the future.</li>
        <li>Create the cost benefit analysis and identify driver impact for any feature to determine priority.</li>
        <li>Create and maintain product documentation including PRD/BRD/FRD’s. </li>
        <li>Create wireframes using Adobe or similar tools.</li>
        <li>Dissect large product feature ideas into bite size user stories</li>
        <li>Influence a cross-functional team of developers, design, and stakeholders to focus on the right things to build</li>
        <li>Manage the UAT and production configuration and implementation changes</li>
        <li>Become the product expert and be able to answer the toughest questions about how it works</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Bachelor's Degree with minimum 5+ years in software Product Management in a B2B/B2C SaaS startup. Preferably in a Fintech/HRTech space.</li>
        <li>Prior experience in Travel/Spend/expense management, HRMS, Accounting, Productivity, or similar software solutions.</li>
        <li>Should have delivered products which have had adoptions in Scale at B2C or B2B in a short period of time, this is a mandatory requirement.</li>
        <li>Experience working directly with Engineering teams, designers, stakeholders.</li>
        <li>Experience with Agile as Product Owner using KanBan and Scrum processes</li>
        <li>Ability to draw wireframe using Adobe or similar tools is a must</li>
        <li>Technical depth and aptitude, including a solid understanding of web/mobile technologies, ROR, Node.js and API services is good to have but not mandatory.</li>
        <li>Good knowledge of project management software (Jira, Github)</li>
        <li>Highly motivated, energetic self-starter who is well organized and takes ownership</li>
        <li>Ability to question traditional/conventional practices and propose change</li>
      </ul>
      <b>Preferred Skills:</b><br/>
        <p>IT Product Management, Jira, API’s, Github, PRD, B2B/ B2B2C SaaS.</p>
      <b>Equal Opportunity Employer:</b><br />
      <p>
        We’re an equal opportunity employer. All applicants will be considered for employment without attention to race, color, religion, sex, sexual orientation, gender identity, national origin, veteran or disability status.
      </p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'cust_supprt_delivery',
      title: 'Customer Support',
      location: [''],
      category: 'Delivery',
      description: `
      <b>Job Overview:</b>
      <p>
        Customer Support Executive is responsible for responding and resolving client reported issues associated to Zaggle - Expense Management Solution received via Support Website, email or through calls.
        Customer Support Executive will also be responsible  for resolving and closing the tickets within the stipulated SLA’s.
        Zaggle Support is often consultative and addresses intermediate to advanced service-related issues.
      </p>
      <b>Responsibility:</b><br />
      <ul>
        <li>Responsible to deliver ‘customer-centric service experiences’ to Zaggle Customers during every interaction.</li>
        <li>Display superior customer service when providing inbound and outbound (email, phone, chat, email etc) application and/or functional support and resolution to customers.</li>
        <li>Maintain a strong passion for solving problems and helping customers, acting as a first line of relationship management.</li>
        <li>Research with the customer to fully diagnose the issue, respond to the customer within established timelines utilizing standard solutions.</li>
        <li>Troubleshoot cases and follow appropriate documentation steps and annotate all the steps or activities undertaken to resolve the issue.</li>
        <li>Regularly provide updates to the client on open cases to gain more information and wherever required escalate issues internally within Zaggle departments to ensure timely resolution.</li>
        <li>Effectively manage client expectations, drive client deliverables and exercise scope to ensure issue resolution.</li>
        <li>Provide consultative expertise to the client, guiding clients through key decisions and tradeoffs while resolving issues.</li>
        <li>Wherever required, effectively conduct basic product functionality trainings with clients remotely.</li>
        <li>Develop and maintain strong functional and technical Zaggle product knowledge including new release and products.</li>
        <li>Deliver outstanding client service to achieve high Customer Support Survey scores.</li>
        <li>Be aware of, and comply with, all corporate policies. </li>
      </ul>
      <h3>Qualifications:</h3>
      <b>Education, Experience & Training required:</b>
      <br />
      <ul>
        <li>Bachelor’s degree or equivalent with one-three years of customer service experience.</li>
        <li>Experience in client-facing/service roles a must and experience in SaaS, EMS, HRMS, Productivity or similar software solutions.</li>
        <li>Ability to understand customer pain points and classify & articulate them in categories such as backend/frontend/UI/UX/customization/product issue etc. for faster logging and resolution.</li>
        <li>Basic understanding of issue logging, maintaining tracker and as required creating an issue ticket for same on ticketing tools.</li>
        <li>One-three years of application troubleshooting experience, preferably Expense Management Solution or Payment Solution, preferably in a multi-channel support environment.</li>
        <li>Strong organizational skills and ability to deliver on commitments</li>
        <li>Ability to pass a background check.</li>
      </ul>
      <b>Job Specific Specialized Knowledge & Skills:</b>
      <br />
      <ul>
        <li>Ability to express thoughts clearly & professionally for fluent customer interaction via telephone, email etc. (English).</li>
        <li>Strong problem resolution skills – proven to engage and interact with internal teams to resolve client issues.</li>
        <li>Must be comfortable in a fast-paced, fluid, and ever-changing work environment and able to facilitate changes as situation requires</li>
        <li>Must possess the ability to work both strategically and tactically.</li>
        <li>Excellent organizational, planning skills and negotiation skills.</li>
        <li>Strong technical aptitude and ability to understand technical concepts quickly.</li>
        <li>Ability to address and manage through ambiguous situations – assess situations, solve problems and make decisions.</li>
        <li>Ability to prioritize and manage workload to meet deadlines.</li>
        <li>Must be results, goal, and customer service orientated.</li>
      </ul>
      <b>Critical Performance Competencies:</b>
      <br />
      <ul>
        <li>Accountability</li>
        <li>Planning and Organization</li>
        <li>Listening</li>
        <li>Communication and Influence</li>
        <li>Personal/ Professional Effectiveness</li>
        <li>Business Acumen/Strategic Business Perspective</li>
        <li>Adaptability/ Flexibility</li>
        <li>Attention to Detail</li>
        <li>Change Management</li>
        <li>Decisiveness/Judgement</li>
        <li>Intelligence</li>
        <li>Tenacity</li>
      </ul>
      <b>Value Competencies:</b>
      <br/>
      <ul>
        <li>Displays leadership through innovation and walks an extra mile to create innovative solutions.</li>
        <li>Displays customer centric passion, empathy & responsibility to the customer.</li>
        <li>Displays excellence and relentless commitment in delivering solutions to customers.</li>
        <li>Displays compete transparency to the customer and takes ownership.</li>
        <li>Displays personal & corporate integrity</li>
        <li>Hires, develops & rewards great people</li>
      </ul>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'presales',
      title: 'PreSales',
      location: [''],
      category: 'Sales',
      description: `
      <b>About Zaggle:</b><br />
      <p>Zaggle is a B2B2C SaaS FinTech company digitizing spends to drive growth and unlock value through innovative and automated workflows.</p>
      <p>We are looking for a suitable candidate with great communication skills and an understanding of the FinTech/HRTech industry.</p>
      <p>As a presales manager you will work closely with various groups/departments such as Sales, Product development, marketing, and customer relations.</p>
      <p>Your primary job will be to understand customer needs and pitching Zaggle products as suitable solutions. You will also be required to actively observe customer behavior and predict future needs for product development. </p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>Responsible for demo and showcase of SaaS offering to prospects and clients and ensuring conversions</li>
        <li>Plan sales strategies in response to market and competitors’ behavior. </li>
        <li>Provide demo to customers, understand customer requirements, and provide product showcase. </li>
        <li>Solution strategy, demo data creations & Storyboarding</li>
        <li>Developing solutions and organizing, planning, creating & delivering compelling proof of concept demonstrations</li>
        <li>Perform gap analysis in the customer requirement and the product offering. Understand the urgency and consult with Business Solutions/Product teams.</li>
        <li>Coordinate and actively follow-up with tech team on the customer requirements and act as a single POC.</li>
        <li>Managing the sales bid process by responding to RFI’s & RFP’s</li>
        <li>Working closely with Sales to ensure successful closure of the sales process</li>
        <li>Liaising with Product Managers to provide feedback from prospects about product requirements</li>
        <li>Sales to implementation handover</li>
        <li>Conceptualize presentation decks for industry events.</li>
        <li>Streamline sales pipeline by regularly monitoring the customers in the pipeline, gather their requirements, and help close the deals by providing proper solutioning.</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Technical knowledge in setting up demo set up with use-cases to showcase the business flow depending on the prospect context</li>
        <li>You have prior experience within presales</li>
        <li>Should have at least 1+ year of experience working in a SaaS firm catering to B2B/B2C/B2B2C customers </li>
        <li>You possess a degree in Computer Science, Engineering, or related fields.</li>
        <li>Solution-oriented analytical skills</li>
        <li>Ability to initiate conversations and make a lasting impact.</li>
        <li>You have excellent interpersonal and communication skills and are adept at working with multiple stakeholders</li>
      </ul>
      <b>Preferred Skills:</b><br/>
        <p>IT Product Management, Jira, PowerPoint, Communication, Customer centric, Presales, Sales, B2B/ B2B2C SaaS.</p>
      <b>Equal Opportunity Employer:</b><br />
      <p>
        We’re an equal opportunity employer. All applicants will be considered for employment without attention to race, color, religion, sex, sexual orientation, gender identity, national origin, veteran or disability status.
      </p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
    {
      slug: 'digital_onboarding',
      title: 'Digital Onboarding',
      location: [''],
      category: 'Delivery',
      description: `
      <b>About Zaggle:</b><br />
      <p>Zaggle is a B2B2C SaaS FinTech company digitizing spends to drive growth and unlock value through innovative and automated workflows.</p>
      <p>We are looking for a Digital onboarding executive to assist us in giving a world class experience to our customer. Be the voice of the product and provide seamless onboarding experience via voice support to customers and help them with any queries.  </p>
      <b>Roles & Responsibility:</b><br />
      <ul>
        <li>Provide consultation on set up of Expense service via the Setup Wizard.</li>
        <li>Provide access to implementation Toolkit and facilitate processing of appropriate system setup forms.</li>
        <li>Train the client project team on end-to-end workflow and the administrative tasks.</li>
        <li>Assist customers with onboarding related queries.</li>
        <li>Be the first point-of-contact for customers setting up their account using self-onboarding platform.</li>
        <li>Perform digital onboarding journey gap analysis and provide regular feedbacks to improve the digital experience.</li>
        <li>Actively follow-up with customers in case of dropouts, understand the problems and provide resolutions.</li>
        <li>Provide consultative expertise to the client including guiding clients through key decisions.</li>
      </ul>
      <b>Requirements:</b><br />
      <ul>
        <li>Minimum 3 years of SaaS enterprise support experience.</li>
        <li>Prior experience of SaaS onboarding platform is desirable.</li>
        <li>Experience in configuring or setting up software for business</li>
        <li>Digital assistance experience required</li>
        <li>Prior experience of working in private banking/insurance customer onboarding support, is preferred.</li>
        <li>Full-time Bachelor’s degree in BCA/B.Tech/B.com are preferred</li>
        <li>Strong analytical and problem-solving skills with a customer service driven focus</li>
        <li>Highly motivated, energetic self-starter who is well organized and takes ownership</li>
        <li>Ability to question traditional/conventional practices and propose change</li>
        <li>Solid written and oral communication skills</li>
      </ul>
      <b>Preferred Skills:</b><br/>
        <p>Voice customer support, strong communication (oral and written), Problem solving skills, goal oriented.</p>
      <b>Equal Opportunity Employer:</b><br />
      <p>
        We’re an equal opportunity employer. All applicants will be considered for employment without attention to race, color, religion, sex, sexual orientation, gender identity, national origin, veteran or disability status.
      </p>
      <div className="text-right"> <b>Send in your resume at <a href=${constants.CAREER_MAIL}> <img src=${endPoints.ZAGGLE_MAIL_ICON} alt="" width="20px" /> careers@zaggle.in</a></b></div>`,
    },
  ],
});

const PRESS_CONSTANTS = Object.freeze({
  AWARDS: [
    {
      keyIndex: 0,
      link: endPoints.PRESS_FINANCIALEXPRESS,
      htmlData: `<span>May 25th, 2020</span>
      <h1>Reimbursement part of salary to change! Wi-Fi, BYOD, home office furniture allowance may be new normal</h1>
      <p>Raj N, the founder of Zaggle, a payments start-up, says pay structure realignment is happening in corporate India as a response to Covid-19.</p>`,
    },
    {
      keyIndex: 1,
      link: endPoints.PRESS_YOUSTORY_ZAGG_VISA_COVID19,
      htmlData: `<span>May 24th, 2020</span>
      <h1>Zaggle Partners with Visa to launch payments solutions for SMEs, startups</h1>
      <p>Under this partnership, Zaggle and Visa will jointly create solutions for SMEs and startups to improve productivity, efficiency, automate processes, and reduce costs.</p>`,
    },
    {
      keyIndex: 2,
      link: endPoints.PRESS_HINDU_ZAGG_VISA_TIE,
      htmlData: `<span>May 23rd, 2020</span>
      <h1>Zaggle, Visa tie up for SME payments</h1>
      <p>Zaggle, a financial technology start-up, has announced a partnership with Visa to launch payment solutions for SMEs and start-ups.</p>`,
    },
    {
      keyIndex: 3,
      link: endPoints.PRESS_BUSINESS_STANDARD,
      htmlData: `<span>May 23rd, 2020</span>
      <h1>Fintech startup Zaggle ties up with Visa for innovative payments solutions for SMEs</h1>
      <p>Mumbai May 23 (PTI) Fintech startup Zaggle on Saturday said it has partnered with paymentsÂ technology major Visa to launch innovative payment solutions for SMEs and startups.</p>`,
    },
    {
      keyIndex: 4,
      link: endPoints.PRESS_ECONOMICTIMES,
      htmlData: `<span>May 23rd, 2020</span>
      <h1>Fintech startup Zaggle joins hands with Visa to launch payment solutions for SMEs, startups</h1>
      <p>Zaggle will leverage Visa’s expertise in the payments space to co-create and build new solutions for SMEs.</p>`,
    },
    {
      keyIndex: 5,
      link: endPoints.PRESS_OUTLOOKINDIA_ZAGG_VISA_TIE,
      htmlData: `<span>May 23rd, 2020</span>
      <h1>Fintech startup Zaggle ties up with Visa for innovative payments solutions for SMEs</h1>
      <p>Fintech startup Zaggle on Saturday said it has partnered with paymentstechnology major Visa to launch innovative payment solutions for SMEs and startups.</p>`,
    },
    {
      keyIndex: 6,
      link: endPoints.LINK_URL_PRESS_COVID19,
      htmlData: `<span>May 8th, 2020</span>
      <h1>I want to see a better me post COVID-19: Zaggle founder Raj N</h1>
      <p>Personally, during the last 20 years plus of my professional life, Raj N, never got an opportunity to take a clean break like this.</p>`,
    },
    {
      keyIndex: 7,
      link: endPoints.LINK_URL_PRESS_BT_BUZZ,
      htmlData: `<span>Apr 22nd, 2020</span>
      <h1>BT Buzz: Mukesh Ambani, Mark Zuckerberg and the $700 billion kirana puzzle</h1>
      <p>The newly-formed Jio Platform houses all of Reliance's digital businesses, such as telecom arm Jio (mobile and broadband), Jio's suite of apps, digital investments (KAI-OS, Haptik), and tech capabilities like big data, AI and IoT</p>`,
    },
    {
      keyIndex: 8,
      link: endPoints.PRESS_PAYMENT_SUMMIT,
      htmlData: `<span>Aug 6th,2019</span>
      <h1>
          Zaggle wins “Best Prepaid Card of the Year At the 7th Edition of Payments &amp; Cards Summit 2019”
      </h1>
      <p>
          Zaggle sought to solve this problem by introducing Zaggle Wave Card which is a
            Multi-brandExperiential Gift Card. Zaggle Wave Card is designed to give employees
            and channelpartners the freedom to choose their own gifts from the best brands in
              each category.
      </p>`,
    },
    {
      keyIndex: 9,
      link: endPoints.PRESS_THEHINDUBUSINESSLINE,
      htmlData: `<span>Aug 02nd, 2019</span>
      <h1>Infosys, TCS, Tech Mahindra bag HYSEA awards</h1>
      <p>Deloitte bagged the top Exporter award with highest revenues from Telangana.</p>`,
    },
    {
      keyIndex: 10,
      link: endPoints.PRESS_HYSEA_SUMMIT,
      htmlData: `<span>Aug 1st,2019</span>
      <h1>
          Zaggle bags “Best Software Product – Enterprise Solutions at 27th Annual HYSEA Innovation Summit”
      </h1>
      <p>Zaggle’s SAVE an innovative solution for Employee Benefits and Expense
            Management, empowering employees to spend smarter. Employees can access all
            their tax-saving reimbursements, Load the employee data on to the server and link it
                to the card for simple and hassle-free funds disbursement.
      </p>`,
    },
    {
      keyIndex: 11,
      link: endPoints.PRESS_IAMAI_SUMMIT,
      htmlData: `<span>Jan 17th,2019</span>
      <h1>Zaggle wins “Best Prepaid Card Solution” at IAMAI India Digital Summit, 2019</h1>
      <p>
          The IAMAI awards felicitate the organizations, teams, and practitioners who have
          surpassed landmark growth and delivered successful business outcomes using digital
                as a medium.
      </p>`,
    },
    {
      keyIndex: 12,
      link: endPoints.PRESS_KETAN_1,
      htmlData: `<span>Oct 05,2018</span>
      <h1>Zaggle partners with Ketan Diamonds</h1>
      <p>Zaggle, a city-based digital payments and group dining deals company, on Thursday announced a partnership with Ketan Diamonds, an online diamond jewellery market.</p>`,
    },
    {
      keyIndex: 13,
      link: endPoints.PRESS_KETAN_2,
      htmlData: `<span>Oct 05, 2018</span>
      <h1>Zaggle announces corporate partnership with Ketan Diamonds</h1>
      <p>Hyderabad-based digital payments and group dining deals company, Zaggle,  has partnered with Ketan Diamonds, a new entrant in the online diamond jewellery market in the country.</p>`,
    },
    {
      keyIndex: 14,
      link: endPoints.PRESS_ZAGGLE_REVENUE,
      htmlData: `<span>Aug 22nd, 2018</span>
      <h1>How Zaggle grew its revenues 6x to Rs 650 crore in just a year</h1>
      <p>Zaggle pivoted from being a gift card provider to a digital payments, cashback and analytics company, and is helping companies and retailers score big on customer loyalty.
      </p>`,
    },
    {
      keyIndex: 15,
      link: endPoints.PRESS_CLICK_PAY,
      htmlData: `<span>July 17th, 2018</span>
      <h1>Enterprise cashback firm Zaggle buys payments company Click&pay</h1>
      <p>Hyderabad-based digital payments and cashback company Zaggle has acquired mobile-based payments firm Click & Pay in a cash-and-stock deal, the company said in a statement</p>`,
    },
    {
      keyIndex: 16,
      link: endPoints.PRESS_ZAGGLE_TCS,
      htmlData: `<span>July 17th, 2018</span>
      <h1>Total sets up digital innovation centre in India with TCS</h1>
      <p>New Delhi, July 17 (PTI) India's largest IT services firm TCS today said it has signed a partnership agreement with Total, a global integrated energy producer and provider, to create a digital innovation centre in India.</p>`,
    },
    {
      keyIndex: 17,
      link: endPoints.PRESS_BRAND_AMBASSADOR,
      htmlData: `<span>Feb 15th, 2018</span>
      <h1>Zaggle announces Hardik Pandya as brand ambassador</h1>
      <p>Zaggle, a payments and group-dining company, has announced cricketer Hardik Pandya as its brand ambassador.</p>`,
    },
    {
      keyIndex: 18,
      link: endPoints.PRESS_CASHBACK_ECONOMICTIMES,
      htmlData: `<span>April 10th, 2017</span>
      <h1>Cashback company Zaggle buys Pennyful</h1>
      <p>The Pennyful team of 15 members will join the 115-team at Zaggle, especially to augment the latter's digital marketing and product technology team, primarily for their consumer-focused business.</p>`,
    },
  ],
});

const MERCHANTS = Object.freeze({
  BENIFIT_GIFT_CARD: [
    {
      keyIndex: 0,
      image: endPoints.MERCHANT_BRAND_AWARENESS,
      alt: 'brand awareness',
      htmlHeader: `<h4>Create brand awareness
      </h4>`,
      htmlData: `<p>Gift cards are an excellent instrument to build brand awareness 
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.MERCHANT_CORPORATE_GIFT,
      alt: 'Corporate gifting',
      htmlHeader: `<h4>Corporate gifting
      </h4>`,
      htmlData: `<p>Employees with high disposable income are very likely to do repeat purchases 
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.MERCHANT_ADVANCE_CAPITAL,
      alt: 'Advance working capital',
      htmlHeader: `<h4>Advance working capital
      </h4>`,
      htmlData: `<p>Payment for the Gift Cards would come in much a head of the redemption
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.MERCHANT_TOUP_SELL,
      alt: 'Opportunity to up-sell',
      htmlHeader: `<h4>Opportunity to up-sell
      </h4>`,
      htmlData: `<p>Additional revenue when the card is redeemed at the store
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.MERCHANT_INCREASED_REVENUES,
      alt: 'Increased revenues',
      htmlHeader: `<h4>Increased revenues
      </h4>`,
      htmlData: `<p>Gift Cards help increase foot traffic and generates sales
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.MERCHANT_MARKETING_CAMPAIGN,
      alt: 'Marketing campaigns',
      htmlHeader: `<h4>Marketing campaigns
      </h4>`,
      htmlData: `<p>Gift cards can be used to conduct effective promotions
      </p>`,
    },
  ],
  MERCHANT_CARD: [
    {
      keyIndex: 0,
      htmlHeader: `<h2>Configurable platform <hr />
    </h2>`,
      htmlData: `<p>The gift card solution is configured as per business needs of the merchant and industry vertical the merchant is in.
    </p>`,
    },
    {
      keyIndex: 1,
      htmlHeader: `<h2>SAAS model<hr />
    </h2>`,
      htmlData: `<p>SAAS model - Merchant can opt for SAAS model whereby they operate the Merchant Gift Card system in house.
    </p>`,
    },
    {
      keyIndex: 2,
      htmlHeader: `<h2 className="underline-left">Instant issuance<hr />
    </h2>`,
      htmlData: `<p>Merchants can issue physical or e-vouchers on the spot with just a few clicks.
    </p>`,
    },
    {
      keyIndex: 3,
      htmlHeader: `<h2 className="underline-left">Multiple redemption modes <hr />
    </h2>`,
      htmlData: `<p>The gift cards can be redeemed on the merchant website or mobile app, the EDC machine, and the POS terminal. 
    </p>`,
    },
    {
      keyIndex: 4,
      htmlHeader: `<h2 className="underline-left">POS Integration <hr />
    </h2>`,
      htmlData: `<p>The existing POS billing system is integrated into the platform leading to seamless redemptions
    </p>`,
    },
  ],
  GIFT_CARD_NEED: [
    {
      keyIndex: 0,
      image: endPoints.MERCHANT_SECURE_PLATFORM,
      alt: 'Secure Platform',
      htmlData: `<p><b>Secure Platform</b>
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.MERCHANT_SECURE_CUSTOMIZATION,
      alt: 'simple Customization',
      htmlData: `<p><b>Simple Customization</b>
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.MERCHANT_MARKETING_SUPPORT,
      alt: 'Marketing support',
      htmlData: `<p><b>Marketing support</b>
      </p>`,
    },
    {
      keyIndex: 3,
      image: endPoints.MERCHANT_MIS_DASHBOARD,
      alt: 'mis dashboard',
      htmlData: `<p><b>MIS & Dashboard  Reports</b>
      </p>`,
    },
    {
      keyIndex: 4,
      image: endPoints.MERCHANT_ALLIANCES,
      alt: 'alliances',
      htmlData: `<p><b>Alliances and Partnerships </b>
      </p>`,
    },
    {
      keyIndex: 5,
      image: endPoints.MERCHANT_MULTIPLE_SALES,
      alt: 'multiple sales',
      htmlData: `<p><b>Multiple Sales Channels</b>
      </p>`,
    },
  ],
  HOW_IT_WORKS: [
    {
      keyIndex: 0,
      image: endPoints.MERCHANT_IMAGE,
      alt: 'merchant',
      htmlData: `<p>Merchant issues physical/e-gift card by entering the customer details
      </p>`,
    },
    {
      keyIndex: 1,
      image: endPoints.MERCHANT_ADD_FUNDS,
      alt: 'merchant and funds',
      htmlData: `<p>Top-up/Reload card with desired <br />amount instantly
      </p>`,
    },
    {
      keyIndex: 2,
      image: endPoints.MERCHANT_TOP_UP,
      alt: 'merchant top up',
      htmlData: `<p>Customer Redeems the point in his future transactions
      </p>`,
    },
  ],
});

const CITY_DETAILS = [
  {
    location: 'Gurgaon',
    address: 'Garage Society, Plot Number 270, Udyog Vihar – Phase II, Sector 21, Gurgaon – 122016',
    phone: '9999856639',
  },
  {
    location: 'Kolkata',
    address: '4th Floor, Shree Manjari Building, 8/1A, Sir William Jones Sarani, Kolkata - 700071',
    phone: '7001780308',
  },
  {
    location: 'Mumbai',
    address: 'Boomerang Building, Ground Floor, B-1004, Yadav Nagar, Chandivali. Powai, Mumbai- 400072',
    phone: '022 48794879',
  },
  {
    location: 'Pune',
    address: '#305, 3 rd Floor, Marisoft-1, Marigold Complex, Kalyani Nagar, Pune- 411014.',
    phone: '020 66021757',
  },
  {
    location: 'Hyderabad',
    address: 'CSR Estate, Plot No.8, Sector - 1 HUDA Techno Enclave, HITEC City, Hyderabad, Telangana - 500081.',
    phone: '040 23119049',
    locationTwo: 'Office Two',
    addressTwo: 'Dwaraka Signature, Plot No 14d, HITEC City, 1, Jai Hind Gandhi Rd, Madhapur, Telangana 500081',
  },
  {
    location: 'Bangalore',
    address: '172, 4th floor, Kesarla complex, 9th Main Rd, Sector 7, HSR Layout, Bengaluru, Karnataka 560102',
    phone: '9742871206',
  },
  {
    location: 'Delhi',
    address: 'Garage Society, Plot no: 270, PHASE -2, Udyog Vihar, Sec -20, Gurgaon-122016',
  },
  {
    location: 'Ahmedabad',
    address: 'D-105, Shiromani Complex, Nr. Nehrunagar Cross Road, Satellite Road, Ahmedabad - 380015.',
    phone: '9825030773',
  },
  {
    location: 'Chennai',
    address: 'Office 919, Regus Grandeur Offices Private Limited, Regus 9th Floor, Olympia Platina, Plot No.33-B, South Phase, Guindy Industrial Estate, Chennai - 600 032.',
    phone: '9566082181',
  },
];

const GetCityLocation = (location) => utils.lodashFind(CITY_DETAILS, { location }) || {};

export {
  PROPEL_CONSTANTS,
  EDGE_CONSTANTS,
  SELECT_CONSTANTS,
  SAVE_CONSTANTS,
  SAVEWIP_CONSTANTS,
  ABOUTUS_CONSTANTS,
  TEAM_CONSTANTS,
  CAREER_CONSTANTS,
  PRESS_CONSTANTS,
  GetCityLocation,
  MERCHANTS,
};



// WEBPACK FOOTER //
// client/containers/StaticPages/constants.js